import Mr, { isAxiosError as Nr } from "axios";
import { cloneDeep as Gr } from "lodash-es";
import _r, { exponentialDelay as Ue, isNetworkOrIdempotentRequestError as Le } from "axios-retry";
import { v4 as Rr } from "uuid";
import { encode as qr } from "js-base64";
import { toSeconds as xr, parse as $r } from "iso8601-duration";
import { startRegistration as Br, startAuthentication as Vr, platformAuthenticatorIsAvailable as Hr } from "@simplewebauthn/browser";
var T = /* @__PURE__ */(t => (t.SESSION_STATE = "SESSION_STATE", t))(T || {}),
  W = /* @__PURE__ */(t => (t.TOKEN_CHANGE = "TOKEN_CHANGE", t.CONVERGENCE_TOKEN_CHANGE = "CONVERGENCE_TOKEN_CHANGE", t))(W || {});
class V {
  static fromString(e) {
    const n = JSON.parse(e);
    if (!Array.isArray(n)) throw new Error("value is not an array");
    if (n.length < 2) throw new Error("value has less than 2 elements");
    const r = Number(n[0]),
      o = Number(n[1]);
    if (Number.isNaN(r) || Number.isNaN(o)) throw new Error("epoch and/or counter are not a number");
    return {
      epoch: r,
      counter: o
    };
  }
  static toString(e) {
    return `[${e.epoch},${e.counter}]`;
  }
  INITIAL_VALUE = {
    counter: -1,
    epoch: 0
  };
  value;
  storageKey;
  cookieProvider;
  logger;
  constructor({
    storageKey: e,
    cookieProvider: n,
    logger: r
  }) {
    this.cookieProvider = n, this.storageKey = e, this.logger = r, this.value = this.load();
  }
  load() {
    const e = this.cookieProvider.getItem(this.storageKey);
    if (!e) return this.INITIAL_VALUE;
    try {
      return V.fromString(e);
    } catch (n) {
      return this.logger.error("error parsing stored clock value", {
        storedValue: e,
        error: n
      }), this.INITIAL_VALUE;
    }
  }
  save() {
    this.cookieProvider.setItem(this.storageKey, V.toString(this.value));
  }
  increment() {
    return this.value.counter >= Number.MAX_SAFE_INTEGER ? (this.value.counter = 0, this.value.epoch++, this.value.epoch >= Number.MAX_SAFE_INTEGER && (this.value.epoch = 0)) : this.value.counter++, this.save(), {
      ...this.value
    };
  }
  update(e) {
    const {
        counter: n,
        epoch: r
      } = this.value,
      {
        counter: o,
        epoch: i
      } = e;
    return r === i ? n < o && (this.value.counter = o) : r < i && (this.value = e), this.save(), {
      ...this.value
    };
  }
}
class Fr {
  /**
   * Get the current datetime according to the OS time.
   * @returns Date - current date/time based on the active clock source
   */
  now() {
    return /* @__PURE__ */new Date();
  }
}
const Me = new Fr();
class Kr {
  listeners = [];
  lastEvent;
  lastDetails;
  subscribe(e) {
    return this.listeners.push(e), this.lastEvent !== void 0 && e(this.lastEvent, this.lastDetails), () => this.unsubscribe(e);
  }
  unsubscribe(e) {
    const n = this.listeners.indexOf(e);
    n > -1 && this.listeners.splice(n, 1);
  }
  getValue() {
    return this.lastEvent;
  }
  getDetails() {
    return this.lastDetails;
  }
}
class Ee extends Kr {
  emit(e, n) {
    this.listeners.forEach(r => r(e, n)), this.lastEvent = e, this.lastDetails = n;
  }
}
const Ne = /* @__PURE__ */new Map();
function s(t, e) {
  return Ne.set(t, e), e;
}
function j(t) {
  const e = Ne.get(t);
  if (!e) throw new Error(`No provider found for key: ${t}`);
  return e;
}
const Se = t => t ? !!t.extras?.isTest : !1,
  zr = (t, e) => t ? e === "content" && !!t.domains[e]?.extras?.isPreview : !1;
let oe;
function Wr(t, e, n) {
  return oe = new Yr(e, n, t), oe;
}
function a() {
  return oe;
}
class Yr {
  _convergenceToken = null;
  config = null;
  deviceInfo = null;
  cookieStorage = {};
  clientStorage = {};
  extraClientSdkMiddlewares;
  userStatus = null;
  // eslint-disable-next-line no-restricted-globals
  _logger = console;
  _sessionEventBus = new Ee();
  _tokenChangeEventBus = new Ee();
  vehicleProfileGrant = null;
  locationCoordinates;
  _observabilityObj;
  AUTH_TOKEN_KEY = "AUTH_TOKEN";
  CLOCK_KEY = "SXM-CLOCK";
  DEVICE_GRANT_KEY = "DEVICE_GRANT";
  logicalClock;
  _retryConditionHandler = () => !1;
  clock = Me;
  userEventsManager = null;
  playbackEventsManager = null;
  constructor(e, n, r) {
    this.cookieStorage = e, this.clientStorage = n, this.config = r, this.logicalClock = new V({
      storageKey: this.CLOCK_KEY,
      cookieProvider: e,
      logger: this._logger
    });
  }
  // @TODO SXMWEB-2307 Pending Care update of login route
  // destroy(): void {
  //   stopListeningToTokenChange();
  // }
  get sessionEventBus() {
    return this._sessionEventBus;
  }
  get tokenChangeEventBus() {
    return this._tokenChangeEventBus;
  }
  get retryConditionHandler() {
    return this._retryConditionHandler;
  }
  set retryConditionHandler(e) {
    this._retryConditionHandler = e;
  }
  get convergenceToken() {
    return this._convergenceToken;
  }
  set convergenceToken(e) {
    this._convergenceToken = e, this.dispatchTokenChangeEvent(W.CONVERGENCE_TOKEN_CHANGE);
  }
  incrementLogicalClock() {
    return this.logicalClock.increment();
  }
  updateLogicalClockValue(e) {
    return this.logicalClock.update(e);
  }
  getRefreshToken() {
    return this.getUserInfo().session?.refreshToken || null;
  }
  setRefreshToken(e) {
    const n = this.getUserInfo();
    n.session && (n.session.refreshToken = e ?? void 0, this.setUserInfo(n.identityGrant, n.session, n.handle));
  }
  /**
   * For getting client's config
   */
  getConfig() {
    return this.config;
  }
  /**
   * For getting client's domain config
   */
  getDomainConfig(e) {
    return this.getConfig()?.domains[e];
  }
  getIsTest() {
    return Se(this.config);
  }
  getIsPreview(e) {
    return zr(this.config, e);
  }
  /**
   * For setting client's config
   */
  setConfig(e) {
    this.config && this.getIsTest() !== Se(e) && (this.clearUserInfo(), j("user.anonymousLogin")()), this.config = e;
  }
  /**
   * For retrieving client device info
   */
  getDeviceInfo() {
    return this.deviceInfo;
  }
  /**
   * For setting client device info
   */
  setDeviceInfo(e) {
    this.deviceInfo = e;
  }
  setUserStatus(e) {
    this.userStatus = e;
  }
  getUserStatus() {
    return this.userStatus;
  }
  setLocationCoordinates(e) {
    this.locationCoordinates = e;
  }
  getLocationCoordinates() {
    return this.locationCoordinates;
  }
  /**
   * For getting user's auth and grant info
   */
  getUserInfo() {
    const e = this.cookieStorage.getItem(this.AUTH_TOKEN_KEY);
    if (!e) return {};
    try {
      return JSON.parse(e);
    } catch (n) {
      return this.getLogger().error("error parsing user info", {
        storedValue: e,
        error: n
      }), {};
    }
  }
  /**
   * For storing user's auth and grant info
   */
  setUserInfo(e, n, r) {
    const o = this.getUserInfo();
    e && (o.identityGrant = e), n && (o.session = n), r && (o.handle = r), this.cookieStorage.setItem(this.AUTH_TOKEN_KEY, JSON.stringify(o), {
      expires: o.session?.refreshTokenExpiresAt ? new Date(o.session.refreshTokenExpiresAt) : void 0
    }), this.dispatchTokenChangeEvent(W.TOKEN_CHANGE);
  }
  clearUserInfo() {
    this.cookieStorage.removeItem(this.AUTH_TOKEN_KEY), this.userStatus = null, this.dispatchTokenChangeEvent(W.TOKEN_CHANGE);
  }
  /**
   * For sending session events
   */
  dispatchSessionEvent(e, n) {
    const r = this.getUserInfo();
    let o = null;
    switch (e) {
      case T.SESSION_STATE:
        if (!r?.session) break;
        o = {
          eventType: e,
          sessionType: r.session.sessionType || "anonymous"
        };
        break;
      default:
        throw new Error(`Unknown session event dispatched: ${e}`);
    }
    o && this.sessionEventBus.emit(o, n);
  }
  dispatchTokenChangeEvent(e) {
    const n = {
      eventType: e,
      timestamp: this.getClock().now().getMilliseconds().toString()
    };
    this.tokenChangeEventBus.emit(n);
  }
  /**
   * For accessing client's local-storage
   */
  getClientStorage() {
    return this.clientStorage;
  }
  setObservabilityObj(e) {
    this._observabilityObj = e;
  }
  getObservabilityObj() {
    return this._observabilityObj;
  }
  async getDeviceGrant() {
    return this.clientStorage.getItem(this.DEVICE_GRANT_KEY);
  }
  async setDeviceGrant(e) {
    return this.clientStorage.setItem(this.DEVICE_GRANT_KEY, e);
  }
  removeDeviceGrant() {
    this.clientStorage.removeItem(this.DEVICE_GRANT_KEY);
  }
  setVehicleProfileGrant(e) {
    this.vehicleProfileGrant = e;
  }
  getVehicleProfileGrant() {
    return this.vehicleProfileGrant;
  }
  getLogger() {
    return this._logger;
  }
  setLogger(e) {
    this._logger = e;
  }
  getExtraClientSdkMiddlewares() {
    return this.extraClientSdkMiddlewares;
  }
  setExtraClientSdkMiddlewares(e) {
    this.extraClientSdkMiddlewares = e;
  }
  /**
   * Returns the current clock instance.
   *
   * If the time domain is not yet available,
   * this method will return the `SystemClock` as a fallback.
   *
   * @returns {IClock} The active clock instance.
   */
  getClock() {
    return this.clock;
  }
  setClock(e) {
    this.clock = e;
  }
}
function Jr(t, e) {
  const n = Mr.create(t);
  return e?.forEach(r => r(n)), n;
}
class se extends Error {
  description;
  code;
  status;
  invalidFields;
  notFoundResourceType;
  extras;
  stack;
  constructor({
    description: e,
    code: n,
    status: r,
    invalidFields: o,
    notFoundResourceType: i,
    stack: c,
    ...u
  }) {
    super(e || `Status Code ${r}`), Object.setPrototypeOf(this, new.target.prototype), Error.captureStackTrace?.(this, this.constructor), this.name = "ServiceError", this.status = r, this.code = n ?? "SERVICE_CODE_UNKNOWN", this.description = e, this.invalidFields = o, this.notFoundResourceType = i, this.stack = c ? `${this.stack || ""}
 caused by ${c}` : this.stack, this.extras = u || {};
  }
}
class Ge extends Error {
  status;
  constructor(e) {
    super("Network Error"), this.name = "Network Error", this.status = e;
  }
}
class Y extends Error {
  status;
  description;
  stack;
  constructor(e, n, r) {
    super(e), this.name = "Generic Error", this.status = n, this.description = e, this.stack = r;
  }
}
class _e extends Error {
  status;
  description;
  constructor(e, n) {
    super(`${e} is disabled`), this.name = "EndpointDisabledError", this.status = n, this.description = `${e} is disabled`;
  }
}
function Xr(t) {
  return t instanceof se || t instanceof Ge || t instanceof Y || t instanceof _e;
}
function Qr(t) {
  if (!t) return new Y("NULL");
  if (!Nr(t)) {
    const e = t;
    return new Y(e.message, void 0, e.stack);
  }
  if (t.response) {
    const e = t.response?.status,
      n = `${t.name} ${t.message} ${t.code || ""} ${t.request?.responseURL || ""}`.trim(),
      r = t?.response?.data || {},
      {
        code: o,
        description: i = n
      } = r;
    return new se({
      ...r,
      description: i,
      code: o,
      status: e,
      stack: t?.stack
    });
  }
  return t.request ? new Ge("RETRY") : new Y(t.message, t.status, t.stack);
}
const Zr = t => e => {
  e.interceptors.response.use(n => n, n => {
    if (Xr(n)) return Promise.reject(n);
    const r = Qr(n);
    return t?.(r), Promise.reject(r);
  });
};
function eo() {
  const t = a().getUserInfo(),
    e = j("time.systemTime");
  if (t) {
    const n = t.session?.accessTokenExpiresAt && new Date(t.session?.accessTokenExpiresAt).getTime() < e.now().getTime();
    if (t.session?.refreshTokenExpiresAt && new Date(t.session?.refreshTokenExpiresAt).getTime() < e.now().getTime()) return a().clearUserInfo(), "anonymous";
    if (n) return "refresh";
    if (t.session?.sessionType) return t.session.sessionType;
  }
  return "anonymous";
}
async function to(t) {
  const e = a();
  try {
    await t.user.getDeviceGrant();
  } catch (r) {
    throw e.getLogger().warn("Unable to get device grant during initialization. Error: ", r), e.dispatchSessionEvent(T.SESSION_STATE), r;
  }
  let n = eo();
  if (n === "authenticated") try {
    return await t.user.getAuthenticatedSession();
  } catch {
    n = "refresh", e.getLogger().warn("Unable to restore previous session, attempting a refresh");
  }
  if (n === "refresh") try {
    return await t.user.refreshToken();
  } catch (r) {
    throw e.clearUserInfo(), r;
  }
  try {
    return await t.user.anonymousLogin();
  } catch (r) {
    if (r instanceof se && r.status === 401) try {
      return e.getLogger().warn("Unable to start anonymous session, purging and retrying"), e.removeDeviceGrant(), e.clearUserInfo(), await t.user.anonymousLogin();
    } catch {
      e.getLogger().warn("Unable to start anonymous session after purge, alerting client"), e.dispatchSessionEvent(T.SESSION_STATE);
    }
  }
}
const no = {
  name: null,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onLoad: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onStart: () => {}
};
function A(t) {
  return Object.assign({}, no, t);
}
async function ro(t) {
  if (t.name === "root") return Promise.resolve();
  if (!t.loader) return Promise.reject("loadDomain(): provided domain node does not have a required loader");
  try {
    return t.module = await t.loader(), t.module?.onLoad();
  } catch (e) {
    const {
        message: n
      } = e,
      r = `Error ${n} loading ${t.name}`;
    return Promise.reject(`loadDomain(): ${r}`);
  }
}
async function oo(t) {
  await Promise.all(t.map(e => ro(e)));
}
async function io(t) {
  await oo(t), ao(t);
}
function so(t) {
  t.module?.onStart?.();
}
function ao(t) {
  return t.map(e => so(e));
}
const co = "sxm-trace-id",
  uo = (t, e) => e ? t.reduce((n, {
    name: r,
    required: o,
    value: i
  }) => {
    const c = e[r],
      d = c == null || typeof c == "string" && c.trim() === "" || Array.isArray(c) && c.length === 0 ? "" : Array.isArray(c) ? c.join(",") : c,
      y = new RegExp(/{([^}]+)}/g).exec(i),
      p = y && y[1],
      C = new RegExp(`[{]${p || r}[}]`, "g");
    if (i.match(C)) {
      const b = i.replace(C, d.toString());
      if (b || o) return {
        ...n,
        [r]: b
      };
    } else if (i.match(/^[\w-_]+$/) && o) return {
      ...n,
      [r]: i
    };
    return n;
  }, e) : {};
function Re(t, e) {
  const n = be(e).split("/") || [],
    r = be(t).split("/") || [];
  return n.length !== r.length ? !1 : n.every((o, i) => {
    if (fo(o)) {
      if (r[i]?.length <= 0) return !1;
    } else if (r[i] !== o) return !1;
    return !0;
  });
}
function be(t) {
  return t?.split("?")[0];
}
function fo(t) {
  return t.startsWith("{") && t.endsWith("}");
}
const lo = t => e => {
    const n = t.domainConfigProvider() || {},
      r = t.transactionHandler;
    let o;
    if ("endPoints" in n) {
      const i = Object.entries(n?.endPoints || {}).find(([c, u]) => Re(e?.url || "", u?.href));
      if (i) {
        const [c, u] = i;
        u?.headers?.[co] && r && (o = r({
          name: c,
          metadata: {
            request: {
              url: e?.url || "",
              method: u.method
            }
          }
        })), e.headers.set(Gr(u.headers));
      }
    }
    return {
      request: e,
      transaction: o
    };
  },
  ho = t => {
    if (t.url && /^https?/.test(t.url)) {
      const n = /^https?:[/]{2}(?:[\w-]+[.]?)+[\w]+[/]/,
        r = t.url?.match(n);
      if (r) {
        const o = t.url?.replace(n, "");
        return {
          ...t,
          baseURL: r[0],
          url: o
        };
      }
    }
    return t;
  },
  go = t => e => {
    const {
        domainConfigProvider: n,
        getEntitlementHash: r
      } = t,
      o = n() || {};
    if (e.params && "endPoints" in o) {
      const i = Object.values(o?.endPoints || {}).find(c => Re(e?.url || "", c?.href));
      i?.queryParams && (e.params.entitlementHash = r(), e.params = uo(i?.queryParams, e.params));
    }
    return e;
  };
function mo(t) {
  return e => {
    const {
        httpHeaderParser: n,
        domainKey: r
      } = t,
      o = po(t);
    let i;
    e.interceptors.request.use(async c => {
      let u = c;
      if (o?.isDisabled) {
        const f = new _e(t.endpointKey || "");
        return t.exceptionHandler?.(f), Promise.reject(f);
      }
      const d = lo(t)(u);
      if (u = d.request, i = d.transaction, n) {
        const f = await n(e, u.headers, r, i?.traceId);
        f && (u.headers = f);
      }
      return u = ho(u), u = go(t)(u), u;
    }), e.interceptors.response.use(c => (i?.finish(), c));
  };
}
function po(t) {
  const {
      domainConfigProvider: e,
      endpointKey: n
    } = t,
    r = e();
  return n && r && "endPoints" in r ? r?.endPoints?.[n] : null;
}
const yo = t => e => {
    const n = t.logProvider();
    e.interceptors.request.use(r => (n.info(`> ${r.method?.toUpperCase()} ${r.baseURL || ""}${r.url?.toString()}`), r)), e.interceptors.response.use(r => (n.info(`< ${r.config.method?.toUpperCase()} ${r.status}:${r.statusText} ${r.config.baseURL || ""}${r.config.url}`), r), r => (n.error(`< ${r.response?.status} ${r.response?.config.url}

${r.message}`), Promise.reject(r)));
  },
  qe = "x-sxm-convergence-token",
  Po = ({
    domainKey: t,
    domainConfigProvider: e,
    tokenProvider: n
  }) => r => {
    const o = e(),
      i = o && t === "user" ? o.endPoints.refresh?.href : null;
    if (r.url?.includes(i)) {
      const c = n.getConvergenceToken();
      c && (r.headers.set(qe, c), n.setConvergenceToken(null));
    }
    return r;
  },
  Co = ({
    domainKey: t,
    domainConfigProvider: e,
    reAuthProvider: n,
    tokenProvider: r
  }) => async o => {
    const i = e(),
      c = i && t === "user" ? i.endPoints.refresh?.href : null,
      u = o.headers[qe];
    return u && r.setConvergenceToken(u),
    // if we just received a convergence token
    (u ||
    // if we received a convergence token during a refresh and were waiting for the refresh to complete
    o.config.url?.includes(c) && r.getConvergenceToken()) && (await n()), o;
  },
  vo = ({
    domainKey: t,
    domainConfigProvider: e,
    tokenProvider: n
  }) => r => {
    const o = e();
    let i = [];
    if (o && t === "user") {
      const c = o.endPoints;
      i = [c?.anonymous?.href, c?.migrateSession?.href, c?.authenticated?.href, c?.refresh?.href];
    }
    if (i.includes(r.config.url)) {
      const c = r?.headers["set-cookie"];
      if (c) {
        const u = c[0].split(";")[0].split("=")[1];
        r.data.refreshToken = u, n.setRefreshToken(u);
      }
    }
    return r;
  },
  Eo = t => e => {
    e.interceptors.request.use(async n => {
      let r = n;
      return r = Po(t)(r), r;
    }), e.interceptors.response.use(async n => {
      let r = n;
      return r = await Co(t)(r), r = vo(t)(r), r;
    }, async n => n.status === 400 && n.message === "invalid-convergence-token" ? (t?.tokenProvider.setConvergenceToken(null), t?.refreshToken()) : Promise.reject(n));
  },
  So = "userServices.identity.invalidCredentials",
  bo = "userServices.identity.locked",
  To = "tokenServicesTeam.sessionService.authorization-pending",
  wo = [So, bo, To],
  Io = ({
    error: t,
    getRefreshTokenExpireAt: e,
    getNow: n
  }) => {
    const r = e(),
      o = t.response?.data && t.response.data.code;
    return wo.some(i => o === i) ? !1 : r ? new Date(r).getTime() > n().getTime() : !1;
  },
  ko = {
    retries: 3,
    retryCondition: Le,
    retryDelay: Ue
  };
function jo(t = 0, e = 2) {
  return Math.pow(e, t) * 1e3;
}
function Ao(t) {
  return Object.assign({}, ko, t);
}
const Do = ({
  endpointKey: t,
  domainConfigProvider: e,
  reAuthProvider: n,
  getRefreshTokenExpireAt: r,
  getSessionType: o,
  shouldRetryRequest: i = () => !1,
  getNow: c
}) =>
// eslint-disable-next-line sonarjs/cognitive-complexity
u => {
  const d = e(),
    f = t && d && "endPoints" in d ? d?.endPoints?.[t] : null;
  let y, p, C;
  f && "retry" in f ? C = f?.retry : d && "retry" in d && (C = d?.retry), C && (y = C?.maxRetryCount, p = P => jo(P, C?.delaySeconds));
  const U = Ao({
    retries: y,
    retryDelay: p || Ue,
    retryCondition: async P => {
      const w = P.request?.url || P.config?.url;
      return (await i(P)) ? !0 : P.response?.status === 429 || P.status === 429 ? !1 : P.response?.status === 401 || P.status === 401 ? !f?.doesNotTriggerSessionRefresh && Io({
        error: P,
        getRefreshTokenExpireAt: r,
        getNow: c
      }) ? (await n(), !0) : !1 : (P.response?.status === 403 || P.status === 403) && o() === "anonymous" ? (console.log(`[CLIENTSDK]: ${w} failed with 403 in undetected anonymous session`), !1) : Le(P);
    }
  });
  _r(u, U);
};
function Oo(t) {
  let e = null;
  return async function (...n) {
    return e || (e = new Promise((r, o) => {
      t(...n).then(i => {
        r(i), e = null;
      }).catch(i => {
        o(i), e = null;
      });
    }), e);
  };
}
function xe() {
  try {
    return Rr();
  } catch {
    return Uo();
  }
}
function Uo() {
  function t(n) {
    return (n | 0).toString(16);
  }
  function e(n) {
    return t(Math.random() * (1 << (n << 2)) ^ Date.now()).slice(-n);
  }
  return [
  // UUID version 4
  e(4) + e(4), e(4), "4" + e(3),
  // {8|9|A|B}xxx
  t(8 | Math.random() * 4) + e(3),
  // Use timestamp to avoid collisions
  Date.now().toString(16).slice(-10) + e(2)].join("-");
}
const Lo = async (t, e, n, r) => {
  const o = () => a().getUserInfo()?.identityGrant?.grant || "",
    i = () => a().getUserStatus()?.identityId || "",
    c = () => a().getUserInfo()?.session?.accessToken || "",
    u = () => a().getRefreshToken() || "",
    d = () => a().getIsTest() || !1,
    f = w => a().getIsPreview(w) || !1,
    y = () => V.toString(a().incrementLogicalClock()),
    p = await a().getDeviceGrant(),
    C = a().getVehicleProfileGrant(),
    b = p?.grant || "",
    U = j("time.systemTime"),
    P = {
      accessToken: c(),
      deviceGrant: b,
      identityGrant: o(),
      identityId: i(),
      refreshToken: u(),
      deviceUuid: b,
      tenantId: "sxm",
      platformName: "browser",
      startGrant: t.defaults.startGrant,
      otpGrant: t.defaults.otpGrant,
      sxmTraceId: r || void 0,
      actionId: xe(),
      sourceTimestamp: U.now().toISOString(),
      vehicleProfileGrant: C,
      magicLinkGrant: t.defaults.magicLinkGrant
    };
  for (const w in e) {
    const k = e[w]?.toString(),
      G = k?.match(/\{(.+?)\}/g)?.map(v => v.slice(1, -1))?.[0];
    if (!G) continue;
    const te = new RegExp("{" + G + "}", "gi");
    if (!(G in P)) continue;
    const _ = P[G];
    _ && (e[w] = k?.replace(te, _));
  }
  return e && (e["x-sxm-clock"
  /* CLOCK */] = y(), d() && (e["X-Sxm-Is-Test"] = "true"), f(n) && (e["x-sxm-preview"] = "true")), e;
};
let K;
const O = (t, e = [], n) => {
    const r = a().getObservabilityObj()?.exceptionHandler,
      o = a().getObservabilityObj()?.startTransaction,
      i = () => a().getClock().now(),
      c = {
        getConvergenceToken: () => a().convergenceToken,
        setConvergenceToken: p => {
          a().convergenceToken = p;
        },
        setRefreshToken: p => a().setRefreshToken(p)
      },
      u = n ? typeof n == "string" ? n : n() : void 0,
      d = typeof t == "string" ? t : t(),
      f = a().getDomainConfig(d);
    K || (K = Oo(async () => {
      try {
        return await j("user.refreshToken")();
      } catch {
        return await j("user.signOut")();
      }
    }));
    const y = [mo({
      endpointKey: u,
      exceptionHandler: r,
      httpHeaderParser: Lo,
      domainConfigProvider: () => f,
      domainKey: d,
      transactionHandler: o,
      setClockValue: p => a().updateLogicalClockValue(p),
      getEntitlementHash: () => a().getUserInfo()?.session?.entitlementHash
    }), Eo({
      domainKey: d,
      domainConfigProvider: () => f,
      getAccessTokenExpireAt: () => a().getUserInfo()?.session?.accessTokenExpiresAt,
      reAuthProvider: K,
      tokenProvider: c,
      refreshToken: () => j("user.refreshToken")(),
      getNow: i
    }), Do({
      domainKey: d,
      endpointKey: u,
      domainConfigProvider: () => f,
      getRefreshTokenExpireAt: () => a().getUserInfo()?.session?.refreshTokenExpiresAt,
      reAuthProvider: K,
      getSessionType: () => a().getUserInfo().session?.sessionType,
      shouldRetryRequest: a().retryConditionHandler,
      getNow: i
    }), Zr(r), ...e];
    return typeof window > "u" && y.push(yo({
      logProvider: () => a().getLogger()
    })), Jr({
      baseURL: f?.baseUrl
    }, y);
  },
  $e = "commerce";
function g() {
  return a().getDomainConfig($e);
}
function m(t) {
  return O(() => $e, [], () => t);
}
async function Mo(t) {
  const e = g();
  if (!e) return Promise.reject("could not find the supplied domain config");
  const n = e?.endPoints?.createBillingProfile;
  return m("createBillingProfile").request({
    method: n?.method,
    url: n?.href || "",
    data: t
  }).then(r => r.data);
}
async function No(t, e, n) {
  const r = g();
  if (!r) return Promise.reject("could not find the supplied domain config");
  const o = r?.endPoints?.createPayment;
  return m("createPayment").request({
    method: o?.method,
    url: o?.href.replace("{billingProfileId}", t).replace("{paymentMethodId}", n) || "",
    data: {
      invoiceId: e
    }
  }).then(i => i.data);
}
async function Go(t) {
  const e = g();
  if (!e) return Promise.reject("could not find the supplied domain config");
  const n = e?.endPoints?.createPaymentMethodsCardSetupToken;
  return m("createPaymentMethodsCardSetupToken").request({
    method: n?.method,
    url: n?.href.replace("{billingProfileId}", t) || ""
  }).then(r => r.data);
}
async function _o(t) {
  const e = g();
  if (!e) return Promise.reject("could not find the supplied domain config");
  const n = e?.endPoints?.createPaymentMethodsFirstCardSetupToken;
  return m("createPaymentMethodsFirstCardSetupToken").request({
    method: n?.method,
    url: n?.href || "",
    data: t
  }).then(r => r.data);
}
async function Ro(t, e) {
  const n = g();
  if (!n) return Promise.reject("could not find the supplied domain config");
  const r = n?.endPoints?.createPaymentSetupToken;
  return m("createPaymentSetupToken").request({
    method: r?.method,
    url: r?.href.replace("{billingProfileId}", t) || "",
    data: {
      invoiceId: e
    }
  }).then(o => o.data);
}
async function qo(t, e) {
  const n = g();
  if (!n) return Promise.reject("could not find the supplied domain config");
  const r = n?.endPoints?.deletePaymentMethod;
  await m("deletePaymentMethod").request({
    method: r?.method,
    url: r?.href.replace("{billingProfileId}", t).replace("{paymentMethodId}", e) || ""
  });
}
async function xo(t) {
  const e = g();
  if (!e) return Promise.reject("could not find the supplied domain config");
  const n = e?.endPoints?.getBalanceDueDetails;
  return m("getBalanceDueDetails").request({
    method: n?.method,
    url: n?.href.replace("{billingProfileId}", t) || ""
  }).then(r => r.data);
}
async function $o(t) {
  const e = g();
  if (!e) return Promise.reject("could not find the supplied domain config");
  const n = e?.endPoints?.getBillingProfile;
  return m("getBillingProfile").request({
    method: n?.method,
    url: n?.href.replace("{billingProfileId}", t) || ""
  }).then(r => r.data);
}
async function Bo(t) {
  const e = g();
  if (!e) return Promise.reject("could not find the supplied domain config");
  const n = e?.endPoints?.getBillingProfileNextBill;
  return m("getBillingProfileNextBill").request({
    method: n?.method,
    url: n?.href.replace("{billingProfileId}", t) || ""
  }).then(r => r.data);
}
async function Vo(t, e) {
  const n = g();
  if (!n) return Promise.reject("could not find the supplied domain config");
  const r = n?.endPoints?.getBillingProfilePaymentHistory;
  return m("getBillingProfilePaymentHistory").request({
    method: r?.method,
    url: r?.href.replace("{billingProfileId}", t) || "",
    params: e
  }).then(o => o.data);
}
async function Ho() {
  const t = g();
  if (!t) return Promise.reject("could not find the supplied domain config");
  const e = t?.endPoints?.getDefaultBillingProfile;
  return m("getDefaultBillingProfile").request({
    method: e?.method,
    url: e?.href || ""
  }).then(n => n.data);
}
async function Fo(t, e) {
  const n = g();
  if (!n) return Promise.reject("could not find the supplied domain config");
  const r = n?.endPoints?.getInvoice;
  return m("getInvoice").request({
    method: r?.method,
    url: r?.href.replace("{billingProfileId}", t).replace("{id}", e) || ""
  }).then(o => o.data);
}
async function Ko(t, e) {
  const n = g();
  if (!n) return Promise.reject("could not find the supplied domain config");
  const r = n?.endPoints?.getInvoices;
  return m("getInvoices").request({
    method: r?.method,
    url: r?.href.replace("{billingProfileId}", t) || "",
    params: e
  }).then(o => o.data);
}
async function zo(t, e) {
  const n = g();
  if (!n) return Promise.reject("could not find the supplied domain config");
  const r = n?.endPoints?.getPaymentMethod;
  return m("getPaymentMethod").request({
    method: r?.method,
    url: r?.href.replace("{billingProfileId}", t).replace("{paymentMethodId}", e) || ""
  }).then(o => o.data);
}
async function Wo(t, e, n) {
  const r = g();
  if (!r) return Promise.reject("could not find the supplied domain config");
  const o = r?.endPoints?.getPaymentMethodHistory;
  return m("getPaymentMethodHistory").request({
    method: o?.method,
    url: o?.href.replace("{billingProfileId}", t).replace("{paymentMethodId}", e) || "",
    params: n
  }).then(i => i.data);
}
async function Yo(t) {
  const e = g();
  if (!e) return Promise.reject("could not find the supplied domain config");
  const n = e?.endPoints?.getPaymentMethods;
  return m("getPaymentMethods").request({
    method: n?.method,
    url: n?.href.replace("{billingProfileId}", t) || ""
  }).then(r => r.data);
}
async function Jo({
  billingProfileId: t,
  paymentMethodId: e,
  stripePaymentMethodId: n
}) {
  const r = g();
  if (!r) return Promise.reject("could not find the supplied domain config");
  const o = r?.endPoints?.setBillingProfileDefaultPaymentMethod;
  return m("setBillingProfileDefaultPaymentMethod").request({
    method: o?.method,
    url: o?.href.replace("{billingProfileId}", t).replace("{paymentMethodId}", e) || "",
    params: {
      stripePaymentMethodId: n
    }
  }).then(i => i.data);
}
async function Xo(t, e) {
  const n = g();
  if (!n) return Promise.reject("could not find the supplied domain config");
  const r = n?.endPoints?.updateBillingProfile;
  return m("updateBillingProfile").request({
    method: r?.method,
    url: r?.href.replace("{billingProfileId}", t) || "",
    data: e
  }).then(o => o.data);
}
async function Qo(t, e, n) {
  const r = g();
  if (!r) return Promise.reject("could not find the supplied domain config");
  const o = r?.endPoints?.updatePaymentMethod;
  return m("updatePaymentMethod").request({
    method: o?.method,
    url: o?.href.replace("{billingProfileId}", t).replace("{paymentMethodId}", e) || "",
    data: n
  }).then(i => i.data);
}
async function Be(t, e) {
  const n = g();
  if (!n) return Promise.reject("could not find the supplied domain config");
  const r = n?.endPoints?.redeemGiftCard;
  return m("redeemGiftCard").request({
    method: r?.method,
    url: r?.href.replace("{billingProfileId}", t),
    data: {
      giftCardTokenId: e
    }
  }).then(o => o.data);
}
async function Zo(t) {
  const e = g();
  if (!e) return Promise.reject("could not find the supplied domain config");
  const n = e?.endPoints?.offersChange;
  return m("offersChange").request({
    method: n?.method,
    url: n?.href || "",
    params: t
  }).then(r => r.data);
}
async function ei(t) {
  const e = g();
  if (!e) return Promise.reject("could not find the supplied domain config");
  const n = e?.endPoints?.offersNew;
  return m("offersNew").request({
    method: n?.method,
    url: n?.href || "",
    params: t
  }).then(r => r.data);
}
async function ti(t) {
  const e = g();
  if (!e) return Promise.reject("could not find the supplied domain config");
  const n = e?.endPoints?.offersSave;
  return m("offersSave").request({
    method: n?.method,
    url: n?.href || "",
    params: t
  }).then(r => r.data);
}
async function ni(t) {
  const e = g();
  if (!e) return Promise.reject("could not find the supplied domain config");
  const n = e?.endPoints?.offerDetails;
  return m("offerDetails").request({
    method: n?.method,
    url: n?.href.replace("{offerId}", t) || ""
  }).then(r => r.data);
}
async function ri(t, e) {
  const n = g();
  if (!n) return Promise.reject("could not find the supplied domain config");
  const r = n?.endPoints?.confirmOrder;
  return m("confirmOrder").request({
    method: r?.method,
    url: r?.href.replace("{orderId}", t) || "",
    ...(e ? {
      data: e
    } : {})
  }).then(o => o.data);
}
async function Q(t) {
  const e = g();
  if (!e) return Promise.reject("could not find the supplied domain config");
  const n = e?.endPoints?.createOrder;
  return m("createOrder").request({
    method: n?.method,
    url: n?.href || "",
    data: t
  }).then(r => r.data);
}
async function oi(t) {
  const e = g();
  if (!e) return Promise.reject("could not find the supplied domain config");
  const n = e?.endPoints?.getOrder;
  return m("getOrder").request({
    method: n?.method,
    url: n?.href.replace("{orderId}", t) || ""
  }).then(r => r.data);
}
async function Ve() {
  const t = g();
  if (!t) return Promise.reject("could not find the supplied domain config");
  const e = t?.endPoints?.getPartnerEntitlements;
  return m("getPartnerEntitlements").request({
    headers: e?.headers,
    method: e?.method,
    url: e?.href || ""
  }).then(n => n.data);
}
async function He(t) {
  const e = g();
  if (!e) return Promise.reject("could not find the supplied domain config");
  const n = e?.endPoints?.activatePartnerEntitlement;
  return m("activatePartnerEntitlement").request({
    headers: n?.headers,
    method: n?.method,
    url: n?.href.replace("{partnerEntitlementId}", t) || ""
  }).then(r => r.data);
}
async function ii() {
  const t = g();
  if (!t) return Promise.reject("could not find the supplied domain config");
  const e = t?.endPoints?.subscriptions;
  return m("subscriptions").request({
    method: e?.method,
    url: e?.href || ""
  }).then(n => n.data);
}
async function si(t) {
  const e = g();
  if (!e) return Promise.reject("could not find the supplied domain config");
  const n = e?.endPoints?.subscriptionForId;
  return m("subscriptionForId").request({
    method: n?.method,
    url: n?.href.replace("{subscriptionId}", t) || ""
  }).then(r => r.data);
}
async function Fe(t, e) {
  const n = g();
  if (!n) return Promise.reject("could not find the supplied domain config");
  const r = n?.endPoints?.registerGiftCard;
  return m("registerGiftCard").request({
    method: r?.method,
    url: r?.href || "",
    data: t,
    ...(e ? {
      params: {
        country: e
      }
    } : {})
  }).then(o => o.data);
}
async function Ke(t, e) {
  const n = g();
  if (!n) return Promise.reject("could not find the supplied domain config");
  const r = n?.endPoints?.restore,
    o = r?.href.replace("{restoreTarget}", t) || "";
  return m("restore").request({
    method: r?.method,
    url: o,
    data: e
  }).then(i => i.data);
}
async function ze(t, e) {
  const n = g();
  if (!n) return Promise.reject("could not find the supplied domain config");
  const r = n?.endPoints?.sync,
    o = r?.href.replace("{syncTarget}", t) || "";
  return m("sync").request({
    method: r?.method,
    url: o,
    data: e
  }).then(i => i.data);
}
async function We(t, e) {
  try {
    return await Zo({
      subscription: t,
      ...e
    });
  } catch (n) {
    return Promise.reject(n);
  }
}
async function Ye(t) {
  try {
    return await ei(t);
  } catch (e) {
    return Promise.reject(e);
  }
}
async function Je(t, e) {
  try {
    return await ti({
      subscription: t,
      ...e
    });
  } catch (n) {
    return Promise.reject(n);
  }
}
async function Xe(t) {
  try {
    return await ni(t);
  } catch (e) {
    return Promise.reject(e);
  }
}
async function Qe(t) {
  try {
    return await Q({
      cancelSubscription: t
    });
  } catch (e) {
    return Promise.reject(e);
  }
}
async function Ze(t, e) {
  try {
    return await ri(t, e);
  } catch (n) {
    return Promise.reject(n);
  }
}
async function et(t) {
  try {
    return await oi(t);
  } catch (e) {
    return Promise.reject(e);
  }
}
async function tt(t) {
  try {
    return await Q({
      newSubscription: t
    });
  } catch (e) {
    return Promise.reject(e);
  }
}
async function nt(t) {
  try {
    return await Q({
      planSwitch: t
    });
  } catch (e) {
    return Promise.reject(e);
  }
}
async function rt(t) {
  try {
    return await Q({
      revokeSubscriptionCancellation: t
    });
  } catch (e) {
    return Promise.reject(e);
  }
}
async function ot() {
  try {
    const {
      items: t
    } = await ii();
    return t;
  } catch (t) {
    return Promise.reject(t);
  }
}
async function it(t) {
  try {
    return await si(t);
  } catch (e) {
    return Promise.reject(e);
  }
}
async function st(t) {
  try {
    return await Mo(t);
  } catch (e) {
    return Promise.reject(e);
  }
}
async function at(t, e, n) {
  try {
    return await No(t, e, n);
  } catch (r) {
    return Promise.reject(r);
  }
}
async function ct(t) {
  try {
    return await Go(t);
  } catch (e) {
    return Promise.reject(e);
  }
}
async function ut(t) {
  try {
    return await _o(t);
  } catch (e) {
    return Promise.reject(e);
  }
}
async function dt(t, e) {
  try {
    return await Ro(t, e);
  } catch (n) {
    return Promise.reject(n);
  }
}
async function ft(t, e) {
  try {
    return await qo(t, e);
  } catch (n) {
    return Promise.reject(n);
  }
}
async function lt(t) {
  try {
    return await xo(t);
  } catch (e) {
    return Promise.reject(e);
  }
}
async function ht(t) {
  try {
    return await $o(t);
  } catch (e) {
    return Promise.reject(e);
  }
}
async function gt(t) {
  try {
    return await Bo(t);
  } catch (e) {
    return Promise.reject(e);
  }
}
async function mt(t, e) {
  try {
    return await Vo(t, e);
  } catch (n) {
    return Promise.reject(n);
  }
}
async function pt() {
  try {
    return await Ho();
  } catch (t) {
    return Promise.reject(t);
  }
}
async function yt(t, e) {
  try {
    return await Fo(t, e);
  } catch (n) {
    return Promise.reject(n);
  }
}
async function Pt(t, e) {
  try {
    return await Ko(t, e);
  } catch (n) {
    return Promise.reject(n);
  }
}
async function Ct(t, e) {
  try {
    return await zo(t, e);
  } catch (n) {
    return Promise.reject(n);
  }
}
async function vt(t, e, n) {
  try {
    return await Wo(t, e, n);
  } catch (r) {
    return Promise.reject(r);
  }
}
async function Et(t) {
  try {
    return await Yo(t);
  } catch (e) {
    return Promise.reject(e);
  }
}
async function St(t) {
  try {
    return await Jo(t);
  } catch (e) {
    return Promise.reject(e);
  }
}
async function bt(t, e) {
  try {
    return await Xo(t, e);
  } catch (n) {
    return Promise.reject(n);
  }
}
async function Tt(t, e, n) {
  try {
    return await Qo(t, e, n);
  } catch (r) {
    return Promise.reject(r);
  }
}
const ai = A({
  name: "commerce",
  onLoad: () => {
    s("commerce.billing.createBillingProfile", st), s("commerce.billing.createPayment", at), s("commerce.billing.createPaymentMethodsCardSetupToken", ct), s("commerce.billing.createPaymentMethodsFirstCardSetupToken", ut), s("commerce.billing.createPaymentSetupToken", dt), s("commerce.billing.deletePaymentMethod", ft), s("commerce.billing.getBalanceDueDetails", lt), s("commerce.billing.getBillingProfile", ht), s("commerce.billing.getBillingProfileNextBill", gt), s("commerce.billing.getBillingProfilePaymentHistory", mt), s("commerce.billing.getDefaultBillingProfile", pt), s("commerce.billing.getInvoice", yt), s("commerce.billing.getInvoices", Pt), s("commerce.billing.getPaymentMethod", Ct), s("commerce.billing.getPaymentMethodHistory", vt), s("commerce.billing.getPaymentMethods", Et), s("commerce.billing.redeemGiftCard", Be), s("commerce.billing.updatePaymentMethod", Tt), s("commerce.billing.setBillingProfileDefaultPaymentMethod", St), s("commerce.billing.updateBillingProfile", bt), s("commerce.eligibility.getOfferDetails", Xe), s("commerce.eligibility.getOffersChange", We), s("commerce.eligibility.getOffersNew", Ye), s("commerce.eligibility.getOffersSave", Je), s("commerce.giftCard.registerGiftCard", Fe), s("commerce.order.cancelSubscription", Qe), s("commerce.order.confirmOrder", Ze), s("commerce.order.getOrder", et), s("commerce.order.newSubscription", tt), s("commerce.order.planSwitch", nt), s("commerce.partnerEntitlements.activatePartnerEntitlement", He), s("commerce.partnerEntitlements.getPartnerEntitlements", Ve), s("commerce.order.revokeSubscriptionCancellation", rt), s("commerce.subscription.subscription", it), s("commerce.subscription.getSubscriptions", ot), s("commerce.restore", Ke), s("commerce.sync", ze);
  }
});
function wt() {
  return {
    billing: {
      createBillingProfile: st,
      createPayment: at,
      createPaymentMethodsCardSetupToken: ct,
      createPaymentMethodsFirstCardSetupToken: ut,
      createPaymentSetupToken: dt,
      deletePaymentMethod: ft,
      getBalanceDueDetails: lt,
      getBillingProfile: ht,
      getBillingProfileNextBill: gt,
      getBillingProfilePaymentHistory: mt,
      getDefaultBillingProfile: pt,
      getInvoice: yt,
      getInvoices: Pt,
      getPaymentMethod: Ct,
      getPaymentMethodHistory: vt,
      getPaymentMethods: Et,
      redeemGiftCard: Be,
      setBillingProfileDefaultPaymentMethod: St,
      updateBillingProfile: bt,
      updatePaymentMethod: Tt
    },
    eligibility: {
      getOfferDetails: Xe,
      getOffersChange: We,
      getOffersNew: Ye,
      getOffersSave: Je
    },
    giftCard: {
      registerGiftCard: Fe
    },
    order: {
      cancelSubscription: Qe,
      confirmOrder: Ze,
      getOrder: et,
      newSubscription: tt,
      planSwitch: nt,
      revokeSubscriptionCancellation: rt
    },
    partnerEntitlements: {
      activatePartnerEntitlement: He,
      getPartnerEntitlements: Ve
    },
    subscription: {
      subscription: it,
      getSubscriptions: ot
    },
    restore: Ke,
    sync: ze
  };
}
const ci = /* @__PURE__ */Object.freeze(/* @__PURE__ */Object.defineProperty({
    __proto__: null,
    default: ai,
    loadAPIs: wt
  }, Symbol.toStringTag, {
    value: "Module"
  })),
  It = "config";
function ae() {
  return a().getDomainConfig(It);
}
function kt(t) {
  return O(() => It, [], () => t);
}
async function jt(t) {
  const e = ae(),
    n = e?.endPoints?.renderApplicationConfigWithSession;
  if (!e) return Promise.reject("could not find the supplied domain config");
  const {
      id: r,
      version: o,
      enableProdMode: i
    } = t,
    u = (n?.href || "").replace("{id}", r).replace("{version}", o);
  return kt("renderApplicationConfigWithSession").request({
    method: n?.method,
    url: u,
    params: {
      enableProdMode: i
    }
  }).then(d => d.data);
}
async function ui(t, e) {
  const n = ae();
  return n ? kt("getLocalizations").request({
    headers: t.headers,
    url: `${n.baseUrl}${t.href}`,
    params: e
  }).then(r => r.data) : Promise.reject("could not find the supplied domain config");
}
async function Z({
  locale: t,
  dictionaryKeys: e,
  dictionaryVersions: n
}) {
  const o = ae()?.endPoints?.getLocalizations,
    i = `${e.filter(c => n[c]).map(c => `${c}:${n[c]}`).join("|")}`;
  return ui({
    ...o
  }, {
    locale: t,
    dictionaries: i
  });
}
A({
  name: "config",
  onLoad: () => {
    s("config.renderApplicationConfigWithSession", jt), s("config.getLocalizations", Z);
  }
});
function di() {
  return {
    renderApplicationConfigWithSession: jt,
    getLocalizations: Z
  };
}
const At = "content";
function E() {
  return a().getDomainConfig(At);
}
function S(t) {
  const n = a().getExtraClientSdkMiddlewares() || [];
  return O(() => At, n, () => t);
}
async function Dt(t) {
  const e = E(),
    n = e?.baseUrl,
    r = e?.endPoints?.browsePageView;
  if (!e) return Promise.reject("could not find the supplied domain config");
  const {
      postData: o,
      pageEntityId: i,
      pageEntityType: c
    } = t,
    u = r?.href?.replace("{pageEntityId}", i)?.replace("{pageEntityType}", c);
  return S("browsePageView").request({
    headers: r?.headers,
    method: r?.method,
    url: `${n}${u}`,
    data: o
  }).then(d => d.data);
}
async function Ot(t) {
  const e = E(),
    n = e?.baseUrl,
    r = e?.endPoints?.browseContainerView;
  if (!e) return Promise.reject("could not find the supplied domain config");
  const {
      postData: o,
      containerId: i,
      pageEntityId: c,
      pageEntityType: u
    } = t,
    d = r?.href?.replace("{pageEntityId}", c)?.replace("{pageEntityType}", u)?.replace("{containerId}", i);
  return S("browseContainerView").request({
    headers: r?.headers,
    method: r?.method,
    url: `${n}${d}`,
    data: o
  }).then(f => f.data);
}
async function Ut(t) {
  const e = E(),
    n = e?.baseUrl,
    r = e?.endPoints?.getPage;
  if (!e) return Promise.reject("could not find the supplied domain config");
  const {
      entityId: o,
      entityType: i
    } = t,
    c = r?.href?.replace("{entityId}", o)?.replace("{entityType}", i);
  return S("getPage").request({
    headers: r?.headers,
    method: r?.method,
    url: `${n}${c}`,
    params: t
  }).then(u => u.data);
}
async function Lt(t) {
  const e = E(),
    n = e?.endPoints?.getContainer,
    r = e?.baseUrl;
  if (!e) return Promise.reject("could not find the supplied domain config");
  const {
      containerUrl: o
    } = t,
    i = n?.href?.replace("{containerUrl}", o);
  return S("getContainer").request({
    headers: n?.headers,
    method: n?.method,
    url: `${r}${i}`
  }).then(c => c.data);
}
async function Mt(t, e) {
  const n = E(),
    r = n?.baseUrl,
    o = n?.endPoints?.getSetSegment;
  if (!n) return Promise.reject("could not find the supplied domain config");
  const i = o?.href?.replace("{paginationUrl}", t);
  return S("getSetSegment").request({
    headers: o?.headers,
    method: o?.method,
    url: `${r}${i}`,
    params: e
  }).then(c => c.data);
}
async function Nt(t) {
  const e = E(),
    n = e?.endPoints?.getUserProgress;
  return e ? S("getUserProgress").request({
    headers: n?.headers,
    method: n?.method,
    url: n?.href,
    data: t
  }).then(r => r.data) : Promise.reject("could not find the supplied domain config");
}
async function Gt(t) {
  const e = E(),
    n = e?.endPoints?.channelPeek,
    r = e?.baseUrl;
  if (!e) return Promise.reject("could not find the supplied domain config");
  const o = n?.href?.replace("{entityId}", t.entityId),
    i = `?entitled=${t.entitled}&size=${t.size}`;
  return S("channelPeek").request({
    headers: n?.headers,
    method: n?.method,
    url: `${r}${o}${i}`,
    data: t
  }).then(c => c.data);
}
async function _t(t) {
  const e = E(),
    n = e?.endPoints?.removeAllContentActivities;
  return e ? S("removeAllContentActivities").request({
    headers: n?.headers,
    method: n?.method,
    url: n?.href,
    params: t
  }).then(r => r.data) : Promise.reject("could not find the supplied domain config");
}
async function Rt(t) {
  const e = E(),
    n = e?.endPoints?.updateContentActivity;
  return e ? S("updateContentActivity").request({
    headers: n?.headers,
    method: n?.method,
    url: n?.href,
    data: t
  }).then(r => r.data) : Promise.reject("could not find the supplied domain config");
}
function qt(t) {
  const e = E(),
    n = e?.endPoints?.bulkEdit;
  return e ? S("bulkEdit").request({
    method: n?.method,
    url: n?.href || "",
    data: t
  }).then(r => r.data) : Promise.reject("could not find the supplied domain config");
}
function xt() {
  const t = E(),
    e = t?.endPoints?.getAllLibraryItems;
  return t ? S("getAllLibraryItems").request({
    method: e?.method,
    url: e?.href || ""
  }).then(n => n.data) : Promise.reject("could not find the supplied domain config");
}
function $t(t) {
  const e = E(),
    n = e?.endPoints?.getLibraryFilterViews;
  if (!e) return Promise.reject("could not find the supplied domain config");
  const {
    filterTypes: r,
    filterViewId: o,
    sortType: i,
    sortOrder: c,
    enableManualSort: u,
    supportedMediaType: d
  } = t;
  return S("getLibraryFilterViews").request({
    method: n?.method,
    url: n?.href || "",
    data: {
      filterTypes: r,
      filterViewId: o,
      sortType: i,
      sortOrder: c,
      enableManualSort: u,
      supportedMediaType: d
    }
  }).then(f => f.data);
}
function Bt(t) {
  const e = E(),
    n = e?.endPoints?.getLibraryFilters;
  return e ? S("getLibraryFilters").request({
    method: n?.method,
    url: n?.href || "",
    params: t
  }).then(r => r.data) : Promise.reject("could not find the supplied domain config");
}
function Vt() {
  const t = E(),
    e = t?.endPoints?.getNewEpisodesView;
  return t ? S("getNewEpisodesView").request({
    method: e?.method,
    url: e?.href || ""
  }).then(n => n.data) : Promise.reject("could not find the supplied domain config");
}
function Ht() {
  const t = E(),
    e = t?.endPoints?.getYourEpisodesView;
  return t ? S("getYourEpisodesView").request({
    method: e?.method,
    url: e?.href || ""
  }).then(n => n.data) : Promise.reject("could not find the supplied domain config");
}
function Ft(t) {
  const e = E(),
    n = e?.endPoints?.updateLibrary;
  return e ? S("updateLibrary").request({
    method: n?.method,
    url: n?.href || "",
    data: t
  }) : Promise.reject("could not find the supplied domain config");
}
function Kt(t) {
  const e = E();
  if (!e) return Promise.reject("could not find the supplied domain config");
  const n = e.endPoints?.getMadeForYouView;
  return S("getMadeForYouView").request({
    method: n?.method,
    url: n?.href || "",
    params: t
  }).then(r => r.data);
}
async function zt(t) {
  const e = E(),
    n = e?.endPoints?.getPivotingContainer;
  return e ? S("getPivotingContainer").request({
    method: n?.method,
    url: n?.href || "",
    params: t
  }).then(r => r.data) : Promise.reject("could not find the supplied domain config");
}
async function Wt({
  contentEntityId: t,
  contentEntityType: e,
  itemEntityIds: n
}) {
  const r = E(),
    o = r?.endPoints?.getStationFeedback;
  return r ? S("getStationFeedback").request({
    headers: o?.headers,
    method: o?.method,
    url: o?.href.replace("{contentEntityId}", t).replace("{contentEntityType}", e) || "",
    params: {
      itemEntityIds: n
    }
  }).then(i => i.data) : Promise.reject("could not find the supplied domain config");
}
A({
  name: "content",
  onLoad: () => {
    s("content.bulkEdit", qt), s("content.channelPeek", Gt), s("content.getBrowsePageView", Dt), s("content.getBrowseContainerView", Ot), s("content.getPage", Ut), s("content.getPivotingContainer", zt), s("content.getContainer", Lt), s("content.getSetSegment", Mt), s("content.getStationFeedback", Wt), s("content.getAllLibraryItems", xt), s("content.getLibraryFilterViews", $t), s("content.getLibraryFilters", Bt), s("content.getNewEpisodesView", Vt), s("content.getUserProgress", Nt), s("content.getYourEpisodesView", Ht), s("content.updateLibrary", Ft), s("content.getMadeForYouView", Kt), s("content.removeAllContentActivities", _t), s("content.updateContentActivity", Rt);
  }
});
function fi() {
  return {
    bulkEdit: qt,
    channelPeek: Gt,
    getBrowsePageView: Dt,
    getBrowseContainerView: Ot,
    getPage: Ut,
    getPivotingContainer: zt,
    getContainer: Lt,
    getSetSegment: Mt,
    getStationFeedback: Wt,
    getAllLibraryItems: xt,
    getLibraryFilterViews: $t,
    getLibraryFilters: Bt,
    getNewEpisodesView: Vt,
    getUserProgress: Nt,
    getYourEpisodesView: Ht,
    updateLibrary: Ft,
    getMadeForYouView: Kt,
    removeAllContentActivities: _t,
    updateContentActivity: Rt
  };
}
function li(t) {
  return typeof globalThis.window?.btoa == "function" ? globalThis.window.btoa(t) : typeof globalThis.Buffer?.from == "function" ? globalThis.Buffer.from(t).toString("base64") : qr(t);
}
const hi = "image";
function gi() {
  return a().getDomainConfig(hi);
}
function Yt(t) {
  const e = gi()?.baseUrl;
  if (!e) throw new Error("No baseUrl found in domain config");
  const n = li(JSON.stringify(t));
  return e.replace("{encodedImageParams}", n);
}
A({
  name: "image",
  onLoad: () => {
    s("image.getImageUrl", Yt);
  }
});
function mi() {
  return {
    getImageUrl: Yt
  };
}
A({
  name: "localization",
  onLoad: () => {
    s("localization.getLocalizations", Z);
  }
});
function pi() {
  return {
    getLocalizations: Z
  };
}
const Jt = {
  name: "root",
  isEnabled: () => !0,
  children: [{
    name: "user",
    loader: async () => (await Promise.resolve().then(() => Sa)).default,
    isEnabled: () => !0
    //getConfig().domains.user
  }, {
    name: "playback",
    loader: async () => (await Promise.resolve().then(() => Us)).default,
    isEnabled: () => !0
  }, {
    name: "commerce",
    loader: async () => (await Promise.resolve().then(() => ci)).default,
    isEnabled: () => !0
  }, {
    name: "time",
    loader: async () => (await Promise.resolve().then(() => Fs)).default,
    isEnabled: () => !0
  }]
};
function yi(t = Jt) {
  const e = [];
  return function n(r) {
    e.push(...r);
    const o = [];
    r.forEach(i => {
      i.children && o.push(...i.children);
    }), o.length > 0 && n(o);
  }([t]), e;
}
function Pi(t, e = Jt) {
  return yi(e).filter(t);
}
const Ci = {
    debug: "🐛",
    trace: "🔍",
    info: "ℹ️",
    log: "💬",
    warn: "❗",
    error: "❌"
  },
  ne = "trace",
  vi = () => typeof window < "u" ? window.LOG_LEVEL || ne : typeof process < "u" && process.env.LOG_LEVEL || ne,
  Ei = (t, e) => e !== "silent" && ["debug", "trace", "info", "log", "warn", "error"].indexOf(t) >= ["debug", "trace", "info", "log", "warn", "error"].indexOf(e);
function Xt(t) {
  const e = n => {
    const r = Ci[n],
      o = t ? `[${t}]` : "";
    return (...i) => {
      const c = vi();
      Ei(n, c) && console[n](`${r} [${n.toUpperCase()}]${o}:`, ...i);
    };
  };
  return {
    debug: e("debug"),
    trace: e("trace"),
    log: e("log"),
    info: e("info"),
    warn: e("warn"),
    error: e("error")
  };
}
Xt();
const Qt = "outreach";
function Si() {
  return a().getDomainConfig(Qt);
}
function bi() {
  return O(() => Qt);
}
const Ti = Xt("outreach");
async function Zt() {
  const t = Si();
  if (!t) return Promise.reject("could not find the specified outreach config");
  const e = t?.endPoints?.getMessage;
  try {
    return bi().request({
      headers: e?.headers,
      method: e?.method,
      url: e?.href
    }).then(n => n.data);
  } catch (n) {
    return Ti.error(`Error retrieving message: ${String(n)}`), Promise.reject({
      messageId: "",
      message: {}
    });
  }
}
A({
  name: "outreach",
  onLoad: () => {
    s("outreach.getMessage", Zt);
  }
});
function wi() {
  return {
    getMessage: Zt
  };
}
const en = "partnerIntegration";
function ce() {
  return a().getDomainConfig(en);
}
function ue(t) {
  return O(() => en, [], () => t);
}
async function tn() {
  const t = ce();
  if (!t) return Promise.reject("could not find the supplied domain config");
  const e = t?.endPoints?.getDetailedDeviceState;
  return ue("getDetailedDeviceState").request({
    method: e?.method,
    url: e?.href || ""
  }).then(n => n.data);
}
async function nn(t) {
  const e = ce();
  if (!e) return Promise.reject("could not find the supplied domain config");
  const n = e?.endPoints?.acceptTermsAndConditions;
  return ue("acceptTermsAndConditions").request({
    method: n?.method,
    url: n?.href || "",
    data: t
  }).then(r => r.data);
}
async function rn(t) {
  const e = ce();
  if (!e) return Promise.reject("could not find the supplied domain config");
  const n = e?.endPoints?.magicLinkRequest;
  return ue("magicLinkRequest").request({
    method: n?.method,
    url: n?.href,
    data: t
  }).then(r => r.data);
}
A({
  name: "partnerIntegration",
  onLoad: () => {
    s("partnerIntegration.getDetailedDeviceState", tn), s("partnerIntegration.acceptTermsAndConditions", nn), s("partnerIntegration.magicLinkRequest", rn);
  }
});
function Ii() {
  return {
    getDetailedDeviceState: tn,
    acceptTermsAndConditions: nn,
    magicLinkRequest: rn
  };
}
const on = "playback";
function I() {
  return a().getDomainConfig(on);
}
function D(t) {
  return O(() => on, [], () => t);
}
function de(t, e = "WEB") {
  return {
    hlsVersion: "V3",
    manifestVariant: t === "channel-linear" ? e : "FULL",
    mtcVersion: "V2"
  };
}
function fe(t) {
  const n = I()?.extras.keyRegex;
  if (n) {
    const r = t.match(n);
    if (r) return r[1];
  }
  throw new Error("playbackServicesTeam.playbackService.key-not-found");
}
async function sn(t, e, n, r = "WEB") {
  const o = I(),
    i = o?.endPoints?.tuneSource;
  if (!o) return Promise.reject("could not find the supplied domain config");
  const c = {
    id: t,
    type: e,
    preferredImageVariant: n,
    ...de(e, r)
  };
  return await D("tuneSource").request({
    method: i?.method,
    url: i?.href || "",
    data: c
  }).then(u => u.data);
}
async function le(t) {
  const e = I(),
    n = e?.endPoints?.getDecryptionKeyFromKeyId;
  return e ? await D("getDecryptionKeyFromKeyId").request({
    method: n?.method,
    url: n?.href?.replace("{keyId}", t)
  }).then(r => r.data) : Promise.reject("could not find the supplied domain config");
}
async function he(t) {
  const e = I(),
    n = e?.endPoints?.getDecryptionKeyFromURL;
  return e ? await D("getDecryptionKeyFromURL").request({
    method: n?.method,
    url: n?.href?.replace("{url}", t)
  }).then(r => r.data) : Promise.reject("could not find the supplied domain config");
}
async function an(t, e) {
  const n = I(),
    r = n?.endPoints?.skip;
  if (!n) return Promise.reject("could not find the supplied domain config");
  const o = {
    id: t,
    type: e
  };
  return await D("skip").request({
    method: r?.method,
    url: r?.href || "",
    data: o
  }).then(i => i.data);
}
async function cn(t, e) {
  const n = I(),
    r = n?.endPoints?.previous;
  if (!n) return Promise.reject("could not find the supplied domain config");
  const o = {
    id: t,
    type: e
  };
  return await D("previous").request({
    method: r?.method,
    url: r?.href || "",
    data: o
  }).then(i => i.data);
}
async function un(t, e, n, r) {
  const o = I(),
    i = o?.endPoints?.peek;
  if (!o) return Promise.reject("could not find the supplied domain config");
  const c = {
    id: t,
    type: e,
    hlsVersion: "V3",
    sourceContextId: n,
    mtcVersion: "V2",
    preferredImageVariant: r
  };
  return await D("peek").request({
    method: i?.method,
    url: i?.href || "",
    data: c
  }).then(u => u.data);
}
async function dn(t) {
  const e = I(),
    n = e?.endPoints?.liveUpdate;
  return e ? D().request({
    method: n?.method,
    url: n?.href || "",
    data: t
  }).then(r => r.data) : Promise.reject("could not find the supplied domain config");
}
async function fn() {
  const t = I(),
    e = t?.endPoints?.streamsStatus;
  return t ? await D("liveUpdate").request({
    method: e?.method,
    url: e?.href || ""
  }).then(n => n.data) : Promise.reject("could not find the supplied domain config");
}
async function ki(t) {
  const e = I(),
    n = e?.endPoints?.telemetryBatchAction;
  return e ? await D("telemetryBatchAction").request({
    method: n?.method,
    url: n?.href || "",
    data: t
  }) : Promise.reject("could not find the supplied domain config");
}
async function ln(t, e) {
  if (!e.includes("playback/key/v1")) return;
  const n = (u, d) => {
      const y = new URL(u).pathname;
      return `${d.endsWith("/") ? d.slice(0, -1) : d}${y}`;
    },
    r = a(),
    o = r.getDomainConfig("playback"),
    i = n(e, o?.baseUrl || "");
  t.open("GET", i, !0);
  const {
    session: c
  } = r.getUserInfo();
  if (c) t.setRequestHeader("Authorization", `Bearer ${c.accessToken}`);else return Promise.reject("No user session found");
}
async function hn() {
  const t = I(),
    e = t?.endPoints?.getLookaround;
  return t ? D("getLookaround").request({
    headers: e?.headers,
    method: e?.method,
    url: e?.href || ""
  }).then(n => n.data) : Promise.reject("could not find the supplied domain config");
}
async function gn() {
  const t = I(),
    e = t?.endPoints?.getLookaroundEpisodes;
  return t ? D("getLookaroundEpisodes").request({
    headers: e?.headers,
    method: e?.method,
    url: e?.href || ""
  }).then(n => n.data) : Promise.reject("could not find the supplied domain config");
}
async function mn(t) {
  const e = I(),
    n = e?.endPoints?.sportScores;
  if (!e) return Promise.reject("could not find the supplied domain config");
  const o = (n?.href || "").replace("{eventId}", t);
  return await D("sportScores").request({
    method: n?.method,
    url: o
  }).then(i => i.data);
}
async function pn(t) {
  const e = I(),
    n = e?.endPoints?.sportEvent;
  if (!e) return Promise.reject("could not find the supplied domain config");
  const o = (n?.href || "").replace("{eventId}", t);
  return await D("sportEvent").request({
    method: n?.method,
    url: o
  }).then(i => i.data);
}
async function yn(t) {
  try {
    const e = fe(t);
    return le(e);
  } catch {
    try {
      return await he(t);
    } catch (e) {
      return Promise.reject(e);
    }
  }
}
var z = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ji(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function Ai(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var Pn = Ai,
  Di = typeof z == "object" && z && z.Object === Object && z,
  Oi = Di,
  Ui = Oi,
  Li = typeof self == "object" && self && self.Object === Object && self,
  Mi = Ui || Li || Function("return this")(),
  Cn = Mi,
  Ni = Cn,
  Gi = function () {
    return Ni.Date.now();
  },
  _i = Gi,
  Ri = /\s/;
function qi(t) {
  for (var e = t.length; e-- && Ri.test(t.charAt(e)););
  return e;
}
var xi = qi,
  $i = xi,
  Bi = /^\s+/;
function Vi(t) {
  return t && t.slice(0, $i(t) + 1).replace(Bi, "");
}
var Hi = Vi,
  Fi = Cn,
  Ki = Fi.Symbol,
  vn = Ki,
  Te = vn,
  En = Object.prototype,
  zi = En.hasOwnProperty,
  Wi = En.toString,
  $ = Te ? Te.toStringTag : void 0;
function Yi(t) {
  var e = zi.call(t, $),
    n = t[$];
  try {
    t[$] = void 0;
    var r = !0;
  } catch {}
  var o = Wi.call(t);
  return r && (e ? t[$] = n : delete t[$]), o;
}
var Ji = Yi,
  Xi = Object.prototype,
  Qi = Xi.toString;
function Zi(t) {
  return Qi.call(t);
}
var es = Zi,
  we = vn,
  ts = Ji,
  ns = es,
  rs = "[object Null]",
  os = "[object Undefined]",
  Ie = we ? we.toStringTag : void 0;
function is(t) {
  return t == null ? t === void 0 ? os : rs : Ie && Ie in Object(t) ? ts(t) : ns(t);
}
var ss = is;
function as(t) {
  return t != null && typeof t == "object";
}
var cs = as,
  us = ss,
  ds = cs,
  fs = "[object Symbol]";
function ls(t) {
  return typeof t == "symbol" || ds(t) && us(t) == fs;
}
var hs = ls,
  gs = Hi,
  ke = Pn,
  ms = hs,
  je = NaN,
  ps = /^[-+]0x[0-9a-f]+$/i,
  ys = /^0b[01]+$/i,
  Ps = /^0o[0-7]+$/i,
  Cs = parseInt;
function vs(t) {
  if (typeof t == "number") return t;
  if (ms(t)) return je;
  if (ke(t)) {
    var e = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = ke(e) ? e + "" : e;
  }
  if (typeof t != "string") return t === 0 ? t : +t;
  t = gs(t);
  var n = ys.test(t);
  return n || Ps.test(t) ? Cs(t.slice(2), n ? 2 : 8) : ps.test(t) ? je : +t;
}
var Es = vs,
  Ss = Pn,
  re = _i,
  Ae = Es,
  bs = "Expected a function",
  Ts = Math.max,
  ws = Math.min;
function Is(t, e, n) {
  var r,
    o,
    i,
    c,
    u,
    d,
    f = 0,
    y = !1,
    p = !1,
    C = !0;
  if (typeof t != "function") throw new TypeError(bs);
  e = Ae(e) || 0, Ss(n) && (y = !!n.leading, p = "maxWait" in n, i = p ? Ts(Ae(n.maxWait) || 0, e) : i, C = "trailing" in n ? !!n.trailing : C);
  function b(v) {
    var L = r,
      x = o;
    return r = o = void 0, f = v, c = t.apply(x, L), c;
  }
  function U(v) {
    return f = v, u = setTimeout(k, e), y ? b(v) : c;
  }
  function P(v) {
    var L = v - d,
      x = v - f,
      ve = e - L;
    return p ? ws(ve, i - x) : ve;
  }
  function w(v) {
    var L = v - d,
      x = v - f;
    return d === void 0 || L >= e || L < 0 || p && x >= i;
  }
  function k() {
    var v = re();
    if (w(v)) return q(v);
    u = setTimeout(k, P(v));
  }
  function q(v) {
    return u = void 0, C && r ? b(v) : (r = o = void 0, c);
  }
  function G() {
    u !== void 0 && clearTimeout(u), f = 0, r = d = o = u = void 0;
  }
  function te() {
    return u === void 0 ? c : q(re());
  }
  function _() {
    var v = re(),
      L = w(v);
    if (r = arguments, o = this, d = v, L) {
      if (u === void 0) return U(d);
      if (p) return clearTimeout(u), u = setTimeout(k, e), b(d);
    }
    return u === void 0 && (u = setTimeout(k, e)), c;
  }
  return _.cancel = G, _.flush = te, _;
}
var ks = Is;
const De = /* @__PURE__ */ji(ks),
  M = {
    days: 864e5,
    hours: 36e5,
    minutes: 6e4,
    seconds: 1e3
  };
function J(t, e) {
  const n = e ?? a().getClock().now();
  return xr($r(t), n) * 1e3;
}
function X(t) {
  let e = t;
  if (e === 0) return "P0D";
  const n = ["P"];
  e < 0 && (n.unshift("-"), e *= -1);
  const r = Math.floor(e / M.days),
    o = Math.floor(e % M.days / M.hours),
    i = Math.floor(e % M.hours / M.minutes),
    c = Math.floor(e % M.minutes / M.seconds),
    u = Math.floor(e % M.seconds),
    d = o || i || c || u;
  if (r > 0 && n.push(`${r}D`), d && n.push("T"), o > 0 && n.push(`${o}H`), i > 0 && n.push(`${i}M`), c > 0 || u > 0) {
    let f = `${c}`;
    u > 0 && (f += `.${u.toString().padStart(3, "0")}`), n.push(`${f}S`);
  }
  return n.join("");
}
class Sn {
  events = [];
  getCacheConfig;
  submitEvents;
  flushInterval = void 0;
  flushing = !1;
  clientStorage;
  eventsKey;
  debounceSetEvents;
  shouldPersistUnSubmittedEvents;
  constructor({
    eventsKey: e,
    storageProvider: n,
    getCacheConfig: r,
    submitEvents: o,
    shouldPersistUnSubmittedEvents: i = () => !0,
    debounceAddEventMs: c = 500
  }) {
    this.clientStorage = n, this.eventsKey = e, this.getCacheConfig = r, this.submitEvents = o, this.shouldPersistUnSubmittedEvents = i, this.debounceSetEvents = De(De(async u => {
      await this.clientStorage.setItem(this.eventsKey, u);
    }, c)), this.startFlushTimer();
  }
  async ready() {
    const e = await this.clientStorage.getItem(this.eventsKey);
    Array.isArray(e) && (this.events = [...e, ...this.events]);
  }
  async addEvent(e, n) {
    await this.addEvents([e], n);
  }
  async addEvents(e, n) {
    this.events.push(...e), await this.processEvents(n);
  }
  async flushEvents(e) {
    if (this.flushing) return;
    this.flushing = !0;
    const n = this.getCacheConfig();
    if (e === "background" && !n.flushOnBackground || e === "appLaunch" && !n.flushOnLaunch) return;
    const r = n.maxEventBatchCount || 20,
      o = Math.ceil(this.events.length / r),
      i = [...this.events];
    this.events = [];
    let c = [];
    const u = [];
    for (let d = 0; d < o; d++) {
      const f = d * r,
        y = d === o - 1 ? i.length : (d + 1) * r,
        p = i.slice(f, y),
        C = this.submitEvents(p).catch(() => {
          c = c.concat(p);
        });
      u.push(C);
    }
    await Promise.allSettled(u), c.length > 0 && this.shouldPersistUnSubmittedEvents() && (this.events = c), this.debounceSetEvents(this.events), this.flushing = !1;
  }
  clearFlushTimer() {
    this.flushInterval && clearInterval(this.flushInterval);
  }
  startFlushTimer() {
    const e = this.getCacheConfig();
    if (!e.flushOnMinInterval) return;
    this.clearFlushTimer();
    const n = J(e.flushOnMinInterval);
    this.flushInterval = setInterval(async () => {
      await this.flushEvents.bind(this)("manual");
    }, n);
  }
  async processEvents(e) {
    const n = this.getCacheConfig();
    e || n.flushOnEventCount && this.events.length >= n.flushOnEventCount ? await this.flushEvents("manual") : this.debounceSetEvents(this.events);
  }
}
function js() {
  const t = I();
  if (!t) throw new Error("Domain config not found");
  return t.extras.telemetryBufferConfig;
}
function As(t) {
  return ki({
    actions: t
  });
}
async function Ds() {
  let t = a().playbackEventsManager;
  return t || (t = new Sn({
    eventsKey: "PLAYBACK_EVENTS",
    storageProvider: a().getClientStorage(),
    getCacheConfig: js,
    submitEvents: As,
    shouldPersistUnSubmittedEvents: () => a().getUserInfo().session?.sessionType === "authenticated"
  }), await t.ready(), a().playbackEventsManager = t), t;
}
async function bn(t, e) {
  await (await Ds()).addEvent(t, e);
}
function Tn() {
  return a().incrementLogicalClock();
}
const Os = A({
  name: "playback",
  onLoad: () => {
    s("playback.peek", un), s("playback.play", sn), s("playback.skip", an), s("playback.previous", cn), s("playback.getDecryptionKeyFromKeyId", le), s("playback.getDecryptionKeyFromUrl", he), s("playback.extractKeyId", fe), s("playback.fetchDecryptionKey", yn), s("playback.liveUpdate", dn), s("playback.streamsStatus", fn), s("playback.telemetryAction", bn), s("playback.getPlaybackTuneRequestMetadata", de), s("playback.setHlsXhrSetup", ln), s("playback.getLookaround", hn), s("playback.getLookaroundEpisodes", gn), s("playback.incrementClock", Tn), s("playback.sportEvent", pn), s("playback.sportScores", mn);
  }
});
function wn() {
  return {
    peek: un,
    play: sn,
    skip: an,
    previous: cn,
    getDecryptionKeyFromKeyId: le,
    getDecryptionKeyFromUrl: he,
    extractKeyId: fe,
    fetchDecryptionKey: yn,
    liveUpdate: dn,
    streamsStatus: fn,
    telemetryAction: bn,
    getPlaybackTuneRequestMetadata: de,
    setHlsXhrSetup: ln,
    getLookaround: hn,
    getLookaroundEpisodes: gn,
    incrementClock: Tn,
    sportEvent: pn,
    sportScores: mn
  };
}
const Us = /* @__PURE__ */Object.freeze(/* @__PURE__ */Object.defineProperty({
    __proto__: null,
    default: Os,
    loadAPIs: wn
  }, Symbol.toStringTag, {
    value: "Module"
  })),
  In = "search";
function H() {
  return a().getDomainConfig(In);
}
function F(t) {
  return O(() => In, [], () => t);
}
function kn(t) {
  const e = H(),
    n = e?.endPoints?.getSearchResults;
  return e ? F("getSearchResults").request({
    headers: n?.headers,
    method: n?.method,
    url: n?.href || "",
    data: t
  }).then(r => r.data) : Promise.reject("could not find the supplied domain config");
}
function jn(t) {
  const e = H(),
    n = e?.endPoints?.getSearchFilters;
  return e ? F("getSearchFilters").request({
    headers: n?.headers,
    method: n?.method,
    url: n?.href || "",
    data: t
  }).then(r => r.data) : Promise.reject("could not find the supplied domain config");
}
function An(t) {
  const e = H(),
    n = e?.endPoints?.getRecentSearches;
  return e ? F("getRecentSearches").request({
    method: n?.method,
    url: n?.href || "",
    params: t
  }).then(r => r.data) : Promise.reject("could not find the supplied domain config");
}
function Dn(t) {
  const e = H(),
    n = e?.endPoints?.getTrendingSearches;
  return e ? F("getTrendingSearches").request({
    method: n?.method,
    url: n?.href || "",
    params: t
  }).then(r => r.data) : Promise.reject("could not find the supplied domain config");
}
function On(t) {
  const e = H(),
    n = e?.endPoints?.autosuggest;
  return e ? F("autosuggest").request({
    method: n?.method,
    url: n?.href || "",
    data: t
  }).then(r => r.data) : Promise.reject("could not find the supplied domain config");
}
A({
  name: "search",
  onLoad: () => {
    s("search.getRecentSearches", An), s("search.getSearchResults", kn), s("search.getTrendingSearches", Dn), s("search.getSearchFilters", jn), s("search.autosuggest", On);
  }
});
function Ls() {
  return {
    getRecentSearches: An,
    getSearchResults: kn,
    getTrendingSearches: Dn,
    getSearchFilters: jn,
    autosuggest: On
  };
}
function ie() {
  if (typeof globalThis.performance == "object") return globalThis.performance;
  throw new Error("Performance API is not available");
}
class Ms {
  serverTime;
  lastSyncTime;
  averageLatency;
  logger = a().getLogger();
  constructor() {
    this.serverTime = Date.now(), this.lastSyncTime = this.getPerformanceNow(), this.averageLatency = 0;
  }
  getPerformanceNow() {
    try {
      return ie().now();
    } catch (e) {
      return this.logger.error(e, "Using Date.now() as fallback"), Date.now();
    }
  }
  setTime(e, n) {
    this.serverTime = e, this.averageLatency = n, this.lastSyncTime = this.getPerformanceNow();
  }
  getTime() {
    const e = this.getPerformanceNow() - this.lastSyncTime;
    return e < 0 ? (this.logger.warn("Time drifted.", {
      elapsedTime: e
    }, "Returning last known server time"), this.serverTime + this.averageLatency) : this.serverTime + this.averageLatency + e;
  }
}
const Un = "time";
function Ln() {
  return a().getDomainConfig(Un);
}
function Ns() {
  return Ln()?.extras;
}
function Gs(t) {
  return O(() => Un, [], () => t);
}
function _s() {
  const t = Ln(),
    e = t?.endPoints?.getMetronome;
  return t ? Gs("getMetronome").request({
    headers: e?.headers,
    method: e?.method,
    url: e?.href || ""
  }) : Promise.reject("could not find the supplied domain config");
}
class Rs {
  buffer = [];
  /*
   * The average latency of the buffer in milliseconds.
   */
  averageLatency = 0;
  add(e, n) {
    const r = n.latencyBufferLength,
      o = n.latencyBufferMinWeight,
      i = n.latencyBufferMaxWeight;
    for (this.buffer.unshift(e); this.buffer.length > r;) this.buffer.pop();
    const c = this.buffer.length,
      u = this.createLatencyWeights(o, i, c);
    this.averageLatency = this.weightedAverage(this.buffer, u);
  }
  createLatencyWeights(e, n, r) {
    if (r === 1) return [n];
    const o = Array.from({
        length: r
      }, (c, u) => u),
      i = (e - n) / (r - 1);
    return o.map(c => n + c * i);
  }
  weightedAverage(e, n) {
    if (n.length !== e.length) throw new Error("Buffer and weights must have the same length");
    const r = e.reduce((i, c, u) => i + c * n[u], 0),
      o = n.reduce((i, c) => i + c, 0);
    return r / o;
  }
}
const Mn = "userEvents";
function Nn() {
  return a().getDomainConfig(Mn);
}
function qs(t) {
  return O(() => Mn, [], () => t);
}
async function xs({
  events: t
}) {
  const e = Nn(),
    n = e?.endPoints?.submit;
  if (!e) return Promise.reject("could not find the supplied domain config");
  const r = {
    events: t
  };
  return qs("submit").request({
    method: n?.method,
    url: n?.href || "",
    data: r
  });
}
function $s() {
  const t = Nn();
  if (!t) throw new Error("Domain config not found");
  return t.extras.userEventsBufferConfig;
}
function Bs(t) {
  return xs({
    events: t
  });
}
async function ge() {
  let t = a().userEventsManager;
  return t || (t = new Sn({
    eventsKey: "USER_EVENTS",
    storageProvider: a().getClientStorage(),
    getCacheConfig: $s,
    submitEvents: Bs
  }), await t.ready(), a().userEventsManager = t), t;
}
async function me(t, e) {
  const r = a().getUserInfo().session?.accessTokenId,
    o = Object.keys(t)[0],
    i = Object.values(t)[0];
  i.eventTokenId = r, t[o] = i, await (await ge()).addEvent(t, e);
}
async function Gn(t) {
  await (await ge()).flushEvents(t);
}
function _n() {
  return a().incrementLogicalClock();
}
function Vs({
  latency: t,
  usingClock: e,
  internalTime: n,
  time: r,
  clockAdjustmentInMS: o,
  appId: i
}) {
  const c = {
    averageLatency: X(t),
    eventId: xe(),
    internalClockTime: new Date(n).toISOString(),
    logicalClock: a().incrementLogicalClock(),
    clockAdjustment: X(o),
    appId: i,
    isTest: a().getIsTest(),
    usingClock: e,
    systemClockTime: (/* @__PURE__ */new Date()).toISOString(),
    time: r.toISOString()
  };
  a().getLogger().info("Time Updated Event", c), me({
    timeUpdated: c
  }, !0);
}
let pe = /*#__PURE__*/(() => {
  class pe {
    static ONE_WEEK_MS = 7 * 24 * 60 * 60 * 1e3;
    latencyBuffer = new Rs();
    currentPoll = null;
    /**
     * "INTERNAL" is the internally managed clock. Ex.: Metronome time.
     *
     * "SYSTEM" is the operating system managed clock. Ex.: Browser time.
     */
    usingClock = "SYSTEM";
    timeManager;
    observabilityObj = a().getObservabilityObj();
    constructor(e) {
      this.timeManager = e, this.initialize();
    }
    getConfig() {
      const e = Ns();
      if (!e) throw new Error("Time config is not available");
      return e;
    }
    async initialize() {
      const {
        metronomeEnabled: e,
        latencyBufferLength: n
      } = this.getConfig();
      if (e) {
        for (let r = 0; r < n; r++) await this.calculateTimeFromServer();
        this.postInitialization();
      }
    }
    /**
     * Clear all timers
     */
    clearAllTimers() {
      this.currentPoll && clearInterval(this.currentPoll);
    }
    postInitialization() {
      const {
          postInitializationPollInterval: e
        } = this.getConfig(),
        n = J(e);
      this.clearAllTimers(), this.currentPoll = setInterval(this.calculateTimeFromServer.bind(this), n);
    }
    async getServerTime() {
      try {
        return [(await _s()).data.time, null];
      } catch (e) {
        return [null, e];
      }
    }
    async calculateTimeFromServer() {
      const e = ie().now(),
        [n, r] = await this.getServerTime(),
        o = ie().now();
      if (r) {
        a().getLogger().error("Error calculating time from server", r);
        return;
      }
      const i = this.now().getTime(),
        c = (o - e) / 2;
      this.latencyBuffer.add(c, this.getConfig()), this.timeManager.setTime(n, this.latencyBuffer.averageLatency);
      const {
          maxDiscrepancyInterval: u
        } = this.getConfig(),
        d = J(u),
        f = Date.now(),
        y = this.timeManager.getTime(),
        p = Math.abs(f - y);
      this.usingClock = p >= d ? "INTERNAL" : "SYSTEM";
      const C = this.now(),
        b = C.getTime() - i,
        U = a().getDeviceInfo()?.appName || "";
      p > pe.ONE_WEEK_MS && this.observabilityObj?.captureMessage?.("ClientSDK: Long clock diff", {
        extra: {
          metronomeTimeMs: n,
          metronomeTime: new Date(n).toISOString(),
          systemTime: new Date(f).toISOString(),
          internalTime: new Date(y).toISOString(),
          maxDiscrepancyInterval: u,
          clockDiffIntervalMs: X(p),
          usingClock: this.usingClock,
          averageLatency: X(this.latencyBuffer.averageLatency)
        }
      }), Vs({
        latency: this.latencyBuffer.averageLatency,
        usingClock: this.usingClock,
        internalTime: this.timeManager.getTime(),
        time: C,
        clockAdjustmentInMS: b,
        appId: U
      });
    }
    /**
     * Get the current datetime according to the clock being used.
     * If the internal clock is selected (due to a significant discrepancy),
     * it returns the time from the managed time; otherwise, it returns the system time.
     *
     * See spec for more details https://ghe.siriusxm.com/client-engineering/clientsdk-specs/blob/main/sdk_implementation/now.md#now-implementation.
     *
     * @returns Date - current date/time based on the active clock source
     */
    now() {
      return this.usingClock === "INTERNAL" ? new Date(this.timeManager.getTime()) : Me.now();
    }
  }
  return pe;
})();
const Hs = A({
  name: "time",
  onLoad: () => {
    const t = new Ms(),
      e = new pe(t);
    s("time.systemTime", e), a().setClock(e);
  }
});
function Rn() {
  return {
    systemTime: j("time.systemTime")
  };
}
const Fs = /* @__PURE__ */Object.freeze(/* @__PURE__ */Object.defineProperty({
    __proto__: null,
    default: Hs,
    loadAPIs: Rn
  }, Symbol.toStringTag, {
    value: "Module"
  })),
  qn = "user";
function l() {
  return a().getDomainConfig(qn);
}
function h(t) {
  return O(() => qn, [], () => t);
}
function Ks() {
  const e = j("time.systemTime").now(),
    n = a().getUserInfo()?.session?.refreshTokenExpiresAt;
  return n ? e.getTime() > new Date(n).getTime() : !0;
}
async function zs() {
  const t = l(),
    e = t?.endPoints?.revokeSessions;
  return t ? h("revokeSessions").request({
    method: e?.method,
    url: e?.href || ""
  }) : Promise.reject("could not find the supplied domain config");
}
async function xn(t) {
  const e = l(),
    n = e?.endPoints?.changeHandleToEmailHandle;
  return e ? h("changeHandleToEmailHandle").request({
    method: n?.method,
    url: n?.href || "",
    data: t
  }) : Promise.reject("could not find the supplied domain config");
}
async function $n(t) {
  const e = l(),
    n = e?.endPoints?.changePassword;
  return e ? h("changePassword").request({
    method: n?.method,
    url: n?.href || "",
    data: t
  }) : Promise.reject("could not find the supplied domain config");
}
async function Bn(t) {
  const e = l(),
    n = e?.endPoints?.changePhoneNumber;
  return e ? h("changePhoneNumber").request({
    method: n?.method,
    url: n?.href || "",
    data: t
  }) : Promise.reject("could not find the supplied domain config");
}
async function Vn() {
  const t = l(),
    e = t?.endPoints?.getAccount;
  return t ? h("getAccount").request({
    method: e?.method,
    url: e?.href || ""
  }).then(n => n.data) : Promise.reject("could not find the supplied domain config");
}
async function Hn(t) {
  const e = l(),
    n = e?.endPoints?.updateAccount;
  return e ? h("updateAccount").request({
    method: n?.method,
    url: n?.href || "",
    data: t
  }) : Promise.reject("could not find the supplied domain config");
}
async function Fn() {
  const t = l(),
    e = t?.endPoints?.issueCastingGrant;
  return t ? h("issueCastingGrant").request({
    method: e?.method,
    url: e?.href || ""
  }).then(n => n.data) : Promise.reject("could not find the supplied domain config");
}
async function Ws(t) {
  const e = l(),
    n = e?.endPoints?.authenticatePassword;
  return e ? h("authenticatePassword").request({
    method: n?.method,
    url: n?.href || "",
    data: t
  }).then(r => r.data) : Promise.reject("could not find the supplied domain config");
}
async function Ys(t) {
  const e = l(),
    n = e?.endPoints?.create;
  return e ? h("create").request({
    method: n?.method,
    url: n?.href || "",
    data: t
  }).then(r => r.data) : Promise.reject("could not find the supplied domain config");
}
async function Js(t) {
  const e = l(),
    n = e?.endPoints?.createV2;
  return e ? h("createV2").request({
    method: n?.method,
    url: n?.href || "",
    data: t
  }).then(r => r.data) : Promise.reject("could not find the supplied domain config");
}
async function Xs(t) {
  const e = l(),
    n = e?.endPoints?.override;
  return e ? h("create").request({
    method: n?.method,
    url: n?.href || "",
    data: t
  }).then(r => r.data) : Promise.reject("could not find the supplied domain config");
}
async function Qs(t) {
  const e = l(),
    n = e?.endPoints?.createDeviceSession;
  return e ? h("createDeviceSession").request({
    method: n?.method,
    url: n?.href || "",
    data: t,
    withCredentials: !0
  }).then(r => r.data) : Promise.reject("could not find the supplied domain config");
}
async function Zs(t) {
  const e = l(),
    n = e?.endPoints?.otpInitiate;
  return e ? h("otpInitiate").request({
    method: n?.method,
    url: n?.href || "",
    data: t
  }).then(r => r.data) : Promise.reject("could not find the supplied domain config");
}
async function ea(t) {
  const e = l(),
    n = e?.endPoints?.otpRedeem;
  return e ? h("otpRedeem").request({
    method: n?.method,
    url: n?.href || "",
    data: t
  }).then(r => r.data) : Promise.reject("could not find the supplied domain config");
}
async function ta(t) {
  const e = l();
  if (!e) return Promise.reject("could not find the supplied domain config");
  const n = e?.endPoints?.otpAuthenticate,
    r = h("otpAuthenticate");
  return r.defaults.otpGrant = t, r.request({
    method: n?.method,
    url: n?.href || ""
  }).then(o => o.data);
}
async function na() {
  const t = l(),
    e = t?.endPoints?.passkeyCreateStart,
    n = t?.extras?.isPasskeyEnabled;
  return !t || !n ? Promise.reject("could not find the supplied domain config or not enabled") : h("passkeyCreateStart").request({
    method: e?.method,
    url: e?.href || ""
  }).then(r => r.data);
}
async function ra(t, e) {
  const n = l(),
    r = n?.endPoints?.passkeyCreateFinish;
  if (!n) return Promise.reject("could not find the supplied domain config");
  const o = h("passkeyCreateFinish");
  return o.defaults.startGrant = t, o.request({
    method: r?.method,
    url: r?.href || "",
    data: e
  }).then(i => i.data);
}
async function oa() {
  const t = l(),
    e = t?.endPoints?.passkeyAuthenticateStart,
    n = t?.extras?.isPasskeyEnabled;
  return !t || !n ? Promise.reject("could not find the supplied domain config or Passkey Disabled") : h("passkeyAuthenticateStart").request({
    method: e?.method,
    url: e?.href || ""
  }).then(r => r.data);
}
async function ia(t, e) {
  const n = l(),
    r = n?.endPoints?.passkeyAuthenticateFinish;
  if (!n) return Promise.reject("could not find the supplied domain config");
  const o = h("passkeyAuthenticateFinish");
  return o.defaults.startGrant = t, o.request({
    method: r?.method,
    url: r?.href || "",
    data: e
  }).then(i => i.data);
}
async function sa(t) {
  const e = l(),
    n = e?.endPoints?.status;
  return e ? h("status").request({
    method: n?.method,
    url: n?.href || "",
    params: t
  }).then(r => r.data) : Promise.reject("could not find the supplied domain config");
}
async function aa() {
  const t = l(),
    e = t?.endPoints?.getIdentity;
  return t ? h("getIdentity").request({
    method: e?.method,
    url: e?.href || ""
  }).then(n => n.data) : Promise.reject("could not find the supplied domain config");
}
async function Kn(t) {
  const e = l(),
    n = e?.endPoints?.recordOfSaleExists;
  return e ? h("recordOfSaleExists").request({
    method: n?.method,
    url: n?.href || "",
    params: t
  }).then(r => r.data) : Promise.reject("could not find the supplied domain config");
}
async function zn() {
  const t = l(),
    e = t?.endPoints?.getProfile;
  return t ? h("getProfile").request({
    method: e?.method,
    url: e?.href || ""
  }).then(n => n.data) : Promise.reject("could not find the supplied domain config");
}
async function Wn(t) {
  const e = l(),
    n = e?.endPoints?.updateUserProfile;
  return e ? h("updateUserProfile").request({
    method: n?.method,
    url: n?.href || "",
    data: t
  }).then(r => r.data) : Promise.reject("could not find the supplied domain config");
}
async function Yn(t) {
  const e = l(),
    n = e?.endPoints?.bypassTastePickingPreference;
  return e ? h("bypassTastePickingPreference").request({
    method: n?.method,
    url: n?.href || "",
    data: t
  }).then(r => r.data) : Promise.reject("could not find the supplied domain config");
}
async function ca(t) {
  const e = l(),
    n = e?.endPoints?.createAutoProfile;
  return e ? h("createAutoProfile").request({
    method: n?.method,
    url: n?.href || "",
    data: t,
    validateStatus: r => r === 409 || r === 201 || r === 200,
    transformResponse: r => {
      const o = JSON.parse(r),
        i = "userServices.profile.profile_service_driver_already_has_profile",
        c = o;
      return c.code === i ? {
        vehicleProfileGrant: c.grant
      } : o;
    }
  }).then(r => r.data) : Promise.reject("could not find the supplied domain config");
}
async function ua() {
  const t = l(),
    e = t?.endPoints?.anonymous;
  return t ? h("anonymous").request({
    method: e?.method,
    url: e?.href || "",
    data: "",
    withCredentials: !0
  }).then(n => n.data) : Promise.reject("could not find the supplied domain config");
}
async function da(t) {
  const e = l(),
    n = e?.endPoints?.migrateSession;
  return e ? h("migrateSession").request({
    method: n?.method,
    url: n?.href || "",
    data: t,
    withCredentials: !0
  }).then(r => r.data) : Promise.reject("could not find the supplied domain config");
}
async function ee() {
  const t = l(),
    e = t?.endPoints?.authenticated;
  return t ? h("authenticated").request({
    method: e?.method,
    url: e?.href || "",
    data: "",
    withCredentials: !0
  }).then(n => n.data) : Promise.reject("could not find the supplied domain config");
}
async function fa(t) {
  const e = l(),
    n = e?.endPoints?.refresh;
  return e ? Ks() ? Promise.reject("refresh token is expired") : h("refresh").request({
    method: n?.method,
    url: n?.href || "",
    data: t,
    withCredentials: !0,
    transformRequest: (o, i) => (delete i.Authorization, JSON.stringify(o))
  }).then(o => o.data) : Promise.reject("could not find the supplied domain config");
}
async function ye(t) {
  const e = l();
  if (!e) return Promise.reject("could not find the supplied domain config");
  const n = e?.endPoints?.magicLinkRedeem;
  return h("magicLinkRedeem").request({
    method: n?.method,
    url: n?.href?.replace("{magicLinkId}", t) || ""
  }).then(r => r.data);
}
async function la(t) {
  const e = l();
  if (!e) return Promise.reject("could not find the supplied domain config");
  const n = e?.endPoints?.authenticateMagicLink,
    r = h("authenticateMagicLink");
  return r.defaults.magicLinkGrant = t, r.request({
    headers: n?.headers,
    method: n?.method,
    url: n?.href || ""
  }).then(o => o.data);
}
async function Jn(t) {
  const e = l();
  if (!e) return Promise.reject("could not find the supplied domain config");
  const n = e?.endPoints?.checkSalStatus;
  return h("checkSalStatus").request({
    method: n?.method,
    url: n?.href || "",
    params: {
      magicLinkGrant: t
    }
  }).then(r => r.data);
}
async function ha(t) {
  const e = l(),
    n = e?.endPoints?.userCodeAuthenticate;
  return e ? h("userCodeAuthenticate").request({
    method: n?.method,
    url: n?.href || "",
    data: {
      deviceCode: t
    },
    withCredentials: !0
  }).then(r => r.data) : Promise.reject("could not find the supplied domain config");
}
async function Xn(t) {
  const e = l(),
    n = e?.endPoints?.userCodeAuthorize;
  return e ? h("userCodeAuthorize").request({
    method: n?.method,
    url: n?.href || "",
    data: {
      userCode: t
    }
  }).then(r => r.data) : Promise.reject("could not find the supplied domain config");
}
async function Qn(t) {
  const e = l(),
    n = e?.endPoints?.userCodeGenerate;
  return e ? h("userCodeGenerate").request({
    method: n?.method,
    url: n?.href || "",
    params: t
  }).then(r => r.data) : Promise.reject("could not find the supplied domain config");
}
async function Zn(t) {
  const e = l(),
    n = e?.endPoints?.linkCodeAuthorize;
  return e ? h("linkCodeAuthorize").request({
    method: n?.method,
    url: n?.href || "",
    data: {
      linkCode: t
    }
  }).then(r => r.data) : Promise.reject("could not find the supplied domain config");
}
const er = "LAST_DEVICE_GRANT_REFRESH_TIMESTAMP_KEY";
async function ga(t) {
  const e = a().getClientStorage(),
    n = await a().getDeviceGrant(),
    r = await e.getItem(er),
    i = j("time.systemTime").now();
  if (!t.extras.minIntervalBetweenDeviceGrantRefreshes || !r || !n || new Date(n.refreshGrantExpiresAt).getTime() - i.getTime() < 0) return !0;
  const d = i.getTime() - Number(r),
    f = J(t.extras.minIntervalBetweenDeviceGrantRefreshes, i);
  return d > f;
}
async function ma(t) {
  const e = l(),
    n = e?.endPoints?.refreshDeviceGrant,
    r = a().getDeviceInfo(),
    o = a().getClientStorage(),
    i = j("time.systemTime");
  return e ? r ? (await ga(e)) ? (t.deviceAttributes || (t.deviceAttributes = tr(r)), h("refreshDeviceGrant").request({
    method: n?.method,
    url: n?.href || "",
    data: t
  }).then(u => (o.setItem(er, i.now().getTime().toString()), u.data))) : Promise.reject("the minimum interval between device grant refreshes not reached") : Promise.reject("could not find the device info") : Promise.reject("could not find the supplied domain config");
}
async function pa() {
  const t = l(),
    e = t?.endPoints?.migrateDeviceGrant;
  return t ? h("migrateDeviceGrant").request({
    method: e?.method,
    url: e?.href || ""
  }).then(n => n.data) : Promise.reject("could not find the supplied domain config");
}
function tr(t) {
  return {
    browser: {
      browserVersion: t.version,
      browserEngineVersion: t.engineVersion,
      browser: t.name,
      userAgent: t.userAgent,
      sdk: t.appName,
      app: t.appName,
      sdkVersion: t.version,
      // @TODO SXMWEB-6320 Replace this with package.json package version
      appVersion: t.version
    }
  };
}
async function ya() {
  const t = l(),
    e = t?.endPoints?.devices,
    n = a().getDeviceInfo();
  if (!t) return Promise.reject("could not find the supplied domain config");
  if (!n) return Promise.reject("could not find the device info");
  const r = tr(n),
    o = {
      devicePlatform: n.devicePlatform,
      deviceAttributes: r,
      grantVersion: "v2"
    };
  return h("devices").request({
    method: e?.method,
    url: e?.href || "",
    data: o
  }).then(i => i.data);
}
async function nr(t) {
  const e = l(),
    n = e?.endPoints?.createAuthenticationChallenge;
  return e ? h("createAuthenticationChallenge").request({
    method: n?.method,
    url: n?.href || "",
    data: t
  }).then(r => r.data) : Promise.reject("could not find the supplied domain config");
}
async function Pa(t) {
  const e = l(),
    n = e?.endPoints?.verifyAuthenticationChallenge;
  return e ? h("verifyAuthenticationChallenge").request({
    method: n?.method,
    url: n?.href || "",
    data: t
  }).then(r => r.data) : Promise.reject("could not find the supplied domain config");
}
async function rr() {
  const t = l(),
    e = t?.endPoints?.recordPrivacyOptionByIdentityId;
  if (!t) return Promise.reject("could not find the supplied domain config");
  await h("recordPrivacyOptionByIdentityId").request({
    method: e?.method,
    url: e?.href || ""
  });
}
async function or() {
  const t = l(),
    e = t?.endPoints?.delete;
  return t ? h("delete").request({
    method: e?.method,
    url: e?.href || ""
  }).then(n => n.data) : Promise.reject("could not find the supplied domain config");
}
async function ir(t) {
  try {
    const e = await ha(t);
    return a().setUserInfo(void 0, e, void 0), a().dispatchSessionEvent(T.SESSION_STATE), e;
  } catch (e) {
    return Promise.reject(e);
  }
}
async function sr(t = !1) {
  const e = a(),
    n = e.getUserInfo(),
    r = j("time.systemTime");
  return !n?.session?.accessToken || new Date(n.session.accessTokenExpiresAt).getTime() < r.now().getTime() || t ? Pe() : (n && (e.dispatchSessionEvent(T.SESSION_STATE), e.setUserInfo(n.identityGrant, n.session, n.handle)), a().getUserInfo());
}
async function Pe() {
  try {
    const t = await ua();
    return a().setUserInfo(void 0, t, void 0), a().dispatchSessionEvent(T.SESSION_STATE), a().getUserInfo();
  } catch (t) {
    return Promise.reject(t);
  }
}
async function R() {
  if (a().getUserInfo().session?.sessionType === "authenticated") return a().dispatchSessionEvent(T.SESSION_STATE, {
    eventType: "session"
  }), a().getUserInfo();
  try {
    const e = await ee();
    return a().setUserInfo(void 0, e, void 0), a().dispatchSessionEvent(T.SESSION_STATE), a().getUserInfo();
  } catch (e) {
    return Promise.reject(e);
  }
}
async function ar(t) {
  try {
    const e = await Qs(t);
    return a().setUserInfo(void 0, e, void 0), a().dispatchSessionEvent(T.SESSION_STATE), a().getUserInfo();
  } catch (e) {
    return Promise.reject(e);
  }
}
async function cr(t) {
  try {
    const e = await da({
      sxmData: t
    });
    return a().setUserInfo(void 0, e, void 0), a().dispatchSessionEvent(T.SESSION_STATE), a().getUserInfo();
  } catch (e) {
    return Promise.reject(e);
  }
}
async function ur(t) {
  const e = a().getUserInfo(),
    n = await Ws(t);
  return a().setUserInfo(n, e.session, t.handle), R();
}
async function dr(t) {
  let e = a().getUserInfo();
  try {
    const n = await Ys(t);
    a().setUserInfo(n, e.session, t.emailAddress);
  } catch (n) {
    return Promise.reject(n);
  }
  e = a().getUserInfo();
  try {
    const n = await ee();
    return a().setUserInfo(e.identityGrant, n, e.handle), a().dispatchSessionEvent(T.SESSION_STATE), a().getUserInfo();
  } catch (n) {
    return Promise.reject(n);
  }
}
async function fr(t) {
  let e = a().getUserInfo();
  try {
    const n = await Js(t);
    a().setUserInfo(n, e.session, t.emailAddress);
  } catch (n) {
    return Promise.reject(n);
  }
  e = a().getUserInfo();
  try {
    const n = await ee();
    return a().setUserInfo(e.identityGrant, n, e.handle), a().dispatchSessionEvent(T.SESSION_STATE), a().getUserInfo();
  } catch (n) {
    return Promise.reject(n);
  }
}
async function lr(t) {
  let e = a().getUserInfo();
  try {
    const n = await Xs(t);
    a().setUserInfo(n, e.session, t.emailAddress);
  } catch (n) {
    return Promise.reject(n);
  }
  e = a().getUserInfo();
  try {
    const n = await ee();
    return a().setUserInfo(e.identityGrant, n, e.handle), a().dispatchSessionEvent(T.SESSION_STATE), a().getUserInfo();
  } catch (n) {
    return Promise.reject(n);
  }
}
async function hr(t) {
  const e = a(),
    n = e.getUserInfo();
  try {
    const r = {
      location: t?.location || e.getLocationCoordinates()
    };
    t?.location && e.setLocationCoordinates(t.location);
    const o = fa(r);
    e.setRefreshToken(null);
    const i = await o;
    return e.setUserInfo(n.identityGrant, i, n.handle), e.dispatchSessionEvent(T.SESSION_STATE, {
      eventType: "refresh"
    }), e.getUserInfo();
  } catch (r) {
    return Promise.reject(r);
  }
}
async function gr({
  identityId: t,
  otpOption: e,
  otpContext: n,
  language: r = "en-US"
}) {
  try {
    return await Zs({
      identityId: t,
      otpOption: e,
      otpContext: n,
      language: r
    });
  } catch (o) {
    return Promise.reject(o);
  }
}
async function mr(t, e) {
  try {
    const {
        grant: n
      } = await ea({
        identityId: t,
        otp: e
      }),
      r = await ta(n),
      o = a().getUserInfo();
    return a().setUserInfo(r, o.session, o.handle), R();
  } catch (n) {
    return Promise.reject(n);
  }
}
async function pr(t) {
  try {
    const {
        grant: e
      } = await ye(t),
      n = await la(e),
      r = a().getUserInfo();
    return a().setUserInfo(n, r.session, r.handle), R();
  } catch (e) {
    return a().getLogger().error("Error authenticating through magic link", e), Promise.reject(e);
  }
}
function Oe(t) {
  return t.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}
function N(t) {
  const e = t.replace(/-/g, "+").replace(/_/g, "/"),
    n = (4 - e.length % 4) % 4;
  return e.padEnd(e.length + n, "=");
}
async function yr(t) {
  try {
    const e = await na();
    t?.("created");
    const n = e.publicKeyCredentialCreationOptions;
    n.user.id = Oe(n.user.id), n.challenge = Oe(n.challenge), delete n.timeout;
    const r = await Br(n);
    return t?.("registered"), r.rawId = N(r.rawId), r.response.attestationObject = N(r.response.attestationObject), r.response.clientDataJSON = N(r.response.clientDataJSON), await ra(e.grant, {
      credential: r
    }), t?.("finished"), Promise.resolve();
  } catch (e) {
    return Promise.reject(e);
  }
}
async function Pr() {
  const t = a().getUserInfo();
  try {
    const e = await oa(),
      n = e.publicKeyCredentialRequestOptions;
    delete n.timeout;
    const r = await Vr(n);
    r.rawId = N(r.rawId), r.response.authenticatorData = N(r.response.authenticatorData), r.response.clientDataJSON = N(r.response.clientDataJSON), r.response.signature = N(r.response.signature), r.response.userHandle && (r.response.userHandle = N(r.response.userHandle));
    const o = await ia(e.grant, {
      credential: r
    });
    return a().setUserInfo(o, t.session, t.handle), R();
  } catch (e) {
    return Promise.reject(e);
  }
}
async function Cr(t) {
  const e = await sa(t);
  return a().setUserStatus(e), e;
}
async function vr() {
  try {
    const t = await Hr();
    return Promise.resolve(t);
  } catch {
    return Promise.resolve(!1);
  }
}
function Er() {
  const t = a().getUserInfo();
  if (t?.session?.accessToken) {
    const e = {
      ...t.session
    };
    return delete e.accessToken, {
      ...t,
      session: e
    };
  }
  return t;
}
async function Ce() {
  try {
    const t = await aa(),
      e = a().getUserInfo();
    return e.identityGrant && (e.identityGrant.emailAddress = t.contact?.emailAddress ?? void 0, e.identityGrant.identityId = t.identityId), a().setUserInfo(e.identityGrant, e.session, e.handle), t;
  } catch (t) {
    return Promise.reject(t);
  }
}
async function Sr() {
  const t = a().getUserInfo(),
    e = t.identityGrant?.identityId;
  if (e) return e;
  if (!t.session || t.session.sessionType !== "authenticated") return null;
  try {
    return (await Ce()).identityId;
  } catch (n) {
    return Promise.reject(n);
  }
}
async function br() {
  const t = await a().getDeviceGrant();
  if (!t) throw new Error("Device ID Unavailable!");
  return t.deviceId;
}
function Tr() {
  const e = a().getUserInfo().session;
  if (!e) throw new Error("Session not initialised!");
  return e.location;
}
async function wr() {
  return a().clearUserInfo(), await j("user.anonymousLogin")(!0);
}
async function Ir() {
  await zs(), a().clearUserInfo(), a().dispatchSessionEvent(T.SESSION_STATE);
}
async function B() {
  try {
    const t = await ya();
    return await a().setDeviceGrant(t), t;
  } catch (t) {
    return Promise.reject(t);
  }
}
async function Ca() {
  try {
    const t = await pa();
    return await a().setDeviceGrant(t), t;
  } catch (t) {
    return a().getLogger().error("Error migrating device grant", t), B();
  }
}
async function va(t) {
  try {
    const e = await ma({
      refreshGrant: t
    });
    return await a().setDeviceGrant(e), e;
  } catch (e) {
    a().getLogger().error("Error refreshing device grant", e);
    const n = e;
    return n.status === 401 || n.status === 403 ? B() : a().getDeviceGrant();
  }
}
async function kr() {
  const e = await a().getDeviceGrant();
  if (!e) return B();
  const n = j("time.systemTime");
  return new Date(e.grantExpiresAt).getTime() < n.now().getTime() ? B() : e.grantVersion === null || e.grantVersion === "v1" ? Ca() : e.refreshGrant && e.refreshGrant.length > 0 ? va(e.refreshGrant) : B();
}
async function jr(t) {
  try {
    const e = await Pa(t);
    return await a().setDeviceGrant(e), e;
  } catch (e) {
    return a().getLogger().error("Error verifying authentication device grant", e), Promise.reject(e);
  }
}
async function Ar(t) {
  try {
    const e = await ca(t);
    a().setVehicleProfileGrant(e.vehicleProfileGrant);
  } catch (e) {
    a().getLogger().error("Error creating device profile", e), Promise.reject(e);
  }
}
const Ea = A({
  name: "user",
  onLoad: () => {
    s("user.getAnonymousSession", Pe), s("user.getAuthenticatedSession", R), s("user.migrateSession", cr), s("user.refreshToken", hr), s("user.anonymousLogin", sr), s("user.login", ur), s("user.signOut", wr), s("user.revokeSessions", Ir), s("user.createUser", dr), s("user.createUserV2", fr), s("user.createOrOverrideUser", lr), s("user.status", Cr), s("user.identity", Ce), s("user.getIdentityId", Sr), s("user.issueCastingGrant", Fn), s("user.magicLinkRedeem", ye), s("user.initializeOTP", gr), s("user.authenticateOTP", mr), s("user.startPasskey", yr), s("user.authenticatePasskey", Pr), s("user.isPasskeySupported", vr), s("user.account", Vn), s("user.updateAccount", Hn), s("user.getProfile", zn), s("user.updateProfile", Wn), s("user.bypassTastePickingPreference", Yn), s("user.changeHandleToEmailHandle", xn), s("user.updatePassword", $n), s("user.updatePhoneNumber", Bn), s("user.getDeviceId", br), s("user.getDeviceGrant", kr), s("user.getLastKnownLocation", Tr), s("user.getRecordOfSale", Kn), s("user.getUserInfo", Er), s("user.userCodeAuthenticate", ir), s("user.userCodeAuthorize", Xn), s("user.userCodeGenerate", Qn), s("user.linkCodeAuthorize", Zn), s("user.checkSalStatus", Jn), s("user.createDriverProfile", Ar), s("user.createAuthenticationChallenge", nr), s("user.verifyAuthenticationChallenge", jr), s("user.createDeviceSession", ar), s("user.recordPrivacyOptionByIdentityId", rr), s("user.authenticateMagicLink", pr), s("user.delete", or);
  }
});
function Dr() {
  return {
    anonymousLogin: sr,
    getAnonymousSession: Pe,
    getAuthenticatedSession: R,
    login: ur,
    migrateSession: cr,
    createUser: dr,
    createUserV2: fr,
    createOrOverrideUser: lr,
    refreshToken: hr,
    startPasskey: yr,
    authenticatePasskey: Pr,
    status: Cr,
    signOut: wr,
    revokeSessions: Ir,
    initializeOTP: gr,
    authenticateOTP: mr,
    isPasskeySupported: vr,
    changeHandleToEmailHandle: xn,
    updatePassword: $n,
    updatePhoneNumber: Bn,
    account: Vn,
    updateAccount: Hn,
    getProfile: zn,
    bypassTastePickingPreference: Yn,
    updateProfile: Wn,
    identity: Ce,
    getIdentityId: Sr,
    getDeviceId: br,
    getDeviceGrant: kr,
    getLastKnownLocation: Tr,
    getRecordOfSale: Kn,
    issueCastingGrant: Fn,
    getUserInfo: Er,
    magicLinkRedeem: ye,
    sessionEvents: a().sessionEventBus,
    tokenChangeEvents: a().tokenChangeEventBus,
    userCodeAuthenticate: ir,
    userCodeAuthorize: Xn,
    userCodeGenerate: Qn,
    linkCodeAuthorize: Zn,
    checkSalStatus: Jn,
    //auto
    createDriverProfile: Ar,
    createAuthenticationChallenge: nr,
    verifyAuthenticationChallenge: jr,
    createDeviceSession: ar,
    recordPrivacyOptionByIdentityId: rr,
    authenticateMagicLink: pr,
    delete: or
  };
}
const Sa = /* @__PURE__ */Object.freeze(/* @__PURE__ */Object.defineProperty({
  __proto__: null,
  default: Ea,
  loadAPIs: Dr
}, Symbol.toStringTag, {
  value: "Module"
}));
A({
  name: "userEvents",
  onLoad: () => {
    s("userEvents.addEvent", me), s("userEvents.incrementClock", _n), s("userEvents.flushEvents", Gn);
  }
});
function ba() {
  return {
    addEvent: me,
    incrementClock: _n,
    flushEvents: Gn
  };
}
const Or = "voice";
function Ta() {
  return a().getDomainConfig(Or);
}
function wa(t) {
  return O(() => Or, [], () => t);
}
function Ur(t) {
  const e = Ta();
  if (!e) return Promise.reject("could not find the supplied domain config");
  const n = e?.endPoints?.voiceAsTextV2;
  return wa("voiceAsTextV2").request({
    headers: n?.headers,
    method: n?.method,
    url: n?.href || "",
    data: t
  }).then(r => r.data);
}
A({
  name: "voice",
  onLoad: () => {
    s("voice.getVoiceAsText", Ur);
  }
});
function Ia() {
  return {
    getVoiceAsText: Ur
  };
}
function ka() {
  return {
    user: Dr(),
    playback: wn(),
    content: fi(),
    localization: pi(),
    commerce: wt(),
    search: Ls(),
    image: mi(),
    userEvents: ba(),
    time: Rn(),
    partnerIntegration: Ii(),
    outreach: wi(),
    voice: Ia(),
    config: di()
  };
}
async function Lr(t, e, n, r, o, i, c, u) {
  const d = Wr(t, n, r);
  i && d.setLogger(i), u && d.setExtraClientSdkMiddlewares(u), e(y => d.setConfig(y)), c && d.setObservabilityObj(c);
  const f = Pi(y => y.isEnabled());
  return await io(f), o && d.setDeviceInfo(o), await ge(), ka();
}
async function Na(t, e, n, r, o, i, c, u, d, f, y, p, C, b, U) {
  const P = await Lr(t, e, n, r, o, f, y, p),
    w = a();
  w && b && w.setLocationCoordinates(b), w && U && (w.retryConditionHandler = U);
  try {
    const k = await P.user.createAuthenticationChallenge({
        deviceId: i
      }),
      q = await d(k.challenge);
    await P.user.verifyAuthenticationChallenge({
      deviceId: i,
      challenge: k.challenge,
      signedChallenge: q
    }), await P.user.createDriverProfile({
      primaryProfile: u,
      oemId: c,
      language: C
    }), await P.user.createDeviceSession({
      location: b
    });
  } catch (k) {
    throw w.getLogger().error("Error creating device session", k), k;
  }
  return P;
}
async function Ga(t, e, n, r, o, i, c, u) {
  try {
    const d = await Lr(t, e, n, r, o, i, c, u);
    return await to(d), d;
  } catch (d) {
    const f = a();
    throw f ? f.getLogger().error(d) : console.error(d), d;
  }
}
export { Ga as bootstrap, Na as bootstrapAdkClient };